// src/components/lockscreen-layouts/LockscreenLayout.tsx
import { styled } from "styled-components";
import { colors, font, media, radius, theme, Container, Flexer, Heading, Logo, Spacer } from "@taxfix/scouts-ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LockscreenLayout = ({
  background = colors.surface.neutral,
  children,
  footer,
  title
}) => {
  return /* @__PURE__ */ _jsx(Container, {
    background,
    children: /* @__PURE__ */ _jsx(Wrapper, {
      children: /* @__PURE__ */ _jsx(Spacer, {
        width: "100%",
        tabletWidth: "504px",
        children: /* @__PURE__ */ _jsxs(Container, {
          padding: "24px",
          children: [/* @__PURE__ */ _jsx(LogoWrapper, {
            "data-pw": "auth-logo",
            children: /* @__PURE__ */ _jsx(Logo, {})
          }), /* @__PURE__ */ _jsx(Container, {
            background: colors.surface.base,
            padding: "24px",
            tabletPadding: "30px 36px",
            radius: radius.large,
            border: `2px solid ${theme.accent1.backgroundLight}`,
            children: /* @__PURE__ */ _jsxs(Flexer, {
              column: true,
              gap: "24px",
              tabletGap: "30px",
              children: [/* @__PURE__ */ _jsx(Heading, {
                weight: font.weight.medium,
                size: font.normal,
                tabletSize: font.large,
                textAlign: "center",
                children: title
              }), children, footer]
            })
          })]
        })
      })
    })
  });
};
var Wrapper = styled.div.withConfig({
  displayName: "LockscreenLayout__Wrapper",
  componentId: "sc-1ofstyx-0"
})(["display:flex;align-items:end;justify-content:center;min-height:100vh;min-height:100dvh;", "{align-items:center;}"], media.tablet);
var LogoWrapper = styled.div.withConfig({
  displayName: "LockscreenLayout__LogoWrapper",
  componentId: "sc-1ofstyx-1"
})(["display:none;width:144px;margin:0 auto 48px;", "{display:block;}"], media.tablet);

// src/components/login-forms/LoginForm.tsx
import { getIsMobileAppMode } from "@taxfix/scouts-helpers";
import { useIsTablet, Button as Button4, Checkbox as Checkbox2, Container as Container3, Flexer as Flexer7, Form as Form4, Input as Input4, ModalLegacy as Modal2, Notice as Notice4, Spacer as Spacer4 } from "@taxfix/scouts-ui";

// src/i18n.ts
import { createTranslationWithMessages } from "@taxfix/scouts-i18n";
var translationMessages = {
  "actions.cancel": ["Cancel", "Cancelar"],
  "actions.continue": ["Continue", "Continuar"],
  "actions.close": ["Close", "Cerrar"],
  "actions.login": ["Log in", "Inicia sesi\xF3n"],
  "actions.logout": ["Log out", "Cerrar sesi\xF3n"],
  "actions.remove": ["Remove", "Eliminar"],
  "actions.resetPassword": ["Reset password", "Rest\xE1urala"],
  "actions.setPassword": ["Set password", "Establecer contrase\xF1a"],
  "actions.signInWithGoogle": ["Sign in with Google", "O inicia sesi\xF3n con Google"],
  "actions.signup": ["Create account", "Continuar"],
  "actions.startNow": ["Start now", "Empieza ahora"],
  "actions.verify": ["Verify", "Enviar"],
  "actions.requestNewLink": ["Request new link", "Solicitar nuevo enlace"],
  "errors.hasNotAgreedToTerms": ["Please agree to terms to continue", "\xA1Oye! No te olvides de aceptar los t\xE9rminos del servicio para continuar"],
  "errors.hasNotFilledAllFields": ["Please fill all fields to continue", "\xA1Ups! Te has dejado alg\xFAn campo por rellenar"],
  "errors.requiresRecentLogin": ["This operation is sensitive and requires recent authentication", "Esta operaci\xF3n es sensible y necesita autenticaci\xF3n reciente"],
  "labels.agreeToTerms": ["I agree to <termsLink>terms of service</termsLink> and <privacyLink>privacy policy</privacyLink>", "Estoy de acuerdo con <termsLink>los t\xE9rminos de servicio</termsLink> y la <privacyLink>pol\xEDtica de privacidad</privacyLink>"],
  "labels.agreeToMarketingEmails": ["I agree to email marketing from Taxfix", "Acepto recibir notificaciones comerciales de Taxfix"],
  "labels.agreeToMarketingEmailsDetails": ["We keep the emails to a minimum. Expect to receive relevant product updates, tax deadline reminders and similar.", "Mandamos las m\xEDnimas notificaciones posibles. Recibir\xE1s informaci\xF3n sobre novedades del servicio, recordatorios de pagos de impuestos y similares. Prometido: nada de spam."],
  "labels.choosePassword": ["Choose your password", "Elige una contrase\xF1a"],
  "labels.email": ["Your email address", "Tu e-mail"],
  "labels.firstName": ["First name", "Nombre"],
  "labels.lastName": ["Last name", "Apellidos"],
  "labels.password": ["Your password", "Tu contrase\xF1a"],
  "labels.passwordConfirm": ["Your password again", "Tu contrase\xF1a otra vez"],
  "labels.rememberMe": ["Keep me logged in", "Mantener sesi\xF3n iniciada"],
  "success.resetPasswordSent": ["An email with further instructions has been successfully sent, please check your inbox", "\xA1Listo! \xC9chale un ojo a tu correo, te hemos enviado un e-mail con las instrucciones."],
  "success.passwordSet": ["Your password has been set successfully, you can now log in", "\xA1Contrase\xF1a establecida con \xE9xito! Ya puedes iniciar sesi\xF3n."],
  "labels.confirmPhoneRemove": ["Are you sure you want to remove {phone}?", "\xBFSeguro que quieres eliminar {phone}?"],
  "labels.sendSmsTo": ["We will send a text message with a verification code{phone, select, _ {.} other { to {phone}.}}", "Te enviaremos un mensaje de texto con el c\xF3digo de verificaci\xF3n{phone, select, _ {.} other { a {phone}.}}"],
  "labels.phoneNumber": ["Phone number", "Tel\xE9fono"],
  "labels.phoneNumberPlaceholder": ["+44 0000 000000", "+34 000 000 000"],
  "labels.verificationCode": ["Verification code", "C\xF3digo de verificaci\xF3n"],
  "description.smsSentTo": ["We have sent a text message with a verification code{phone, select, _ {.} other { to {phone}}}", "Hemos enviado un mensaje de texto con el c\xF3digo de verificaci\xF3n{phone, select, _ {.} other { a {phone}}}"],
  "result.phoneAdded": ["{phone} is now set up as your phone number", "{phone} a\xF1adido para la autenticaci\xF3n en dos pasos"],
  "result.deletedPhone": ["Deleted {phone}", "Eliminado {phone}"],
  "result.deletedTotp": ["Authenticator app removed successfully", "Aplicaci\xF3n de autenticaci\xF3n eliminada"],
  "errors.invalidLogin": [`Sorry, that email or password didn't work`, "Lo sentimos, e-mail o contrase\xF1a incorrectos"],
  "errors.invalidPhone": ["The phone number provided is incorrect. Please use the format [+][country code][number including area code].", "El n\xFAmero de tel\xE9fono introducido no es correcto. Por favor, usa el formato [+][c\xF3digo de pa\xEDs][n\xFAmero de tel\xE9fono]."],
  "errors.mfaRequired": ["2-step authentication is required to complete sign-in", "Segundo factor de autenticaci\xF3n es necesario para poder iniciar sesi\xF3n"],
  "errors.invalidVerificationCode": ["Verification code invalid. Please double check and try again.", "El c\xF3digo de verificaci\xF3n es incorrecto. Por favor, compruebalo y prueba de nuevo."],
  "errors.expiredVerificationCode": ["This code has expired", "Este c\xF3digo ha caducado"],
  "errors.tooManyRequests": ["We have blocked requests from this device due to suspicious activity. Please try again later.", "Hemos bloqueado las peticiones de este dispositivo debido a una actividad sospechosa. Prueba de nuevo m\xE1s tarde."],
  "errors.phoneAlreadyUsed": ["The phone number is already in use for this account", "El n\xFAmero de tel\xE9fono ya est\xE1 en uso para esta cuenta"],
  "errors.emailAlreadyUsed": ["Email already in use", "Email ya est\xE1 en uso"],
  "errors.weakPassword": ["Password is too weak", "La contrase\xF1a es demasiado d\xE9bil"],
  "errors.networkRequestFailed": ["It seems you're offline. Please check your internet connection and try again.", "Parece que est\xE1s sin conexi\xF3n. Comprueba tu conexi\xF3n a internet e int\xE9ntalo de nuevo."],
  "errors.popupBlocked": ["The popup has been blocked by the browser. Please allow popups and try again.", "El popup ha sido bloqueado por el navegador. Por favor, permite los popups e int\xE9ntalo de nuevo."],
  "errors.popupClosedByUser": ["The popup has been closed before completing the sign in. Please try again.", "El popup se ha cerrado antes de completar el inicio de sesi\xF3n. Por favor, int\xE9ntalo de nuevo."],
  "errors.userCancelled": ["The sign in was cancelled before completing. Please try again.", "El inicio de sesi\xF3n se ha cancelado antes de completarse. Por favor, int\xE9ntalo de nuevo."],
  "errors.invalidSetPasswordLink": ["Link is invalid or expired.", "El enlace no es v\xE1lido o ha caducado."],
  "error.passwordNotMatching": ["Passwords do not match", "Las contrase\xF1as no coinciden"],
  "legal.recaptcha": ["This site is protected by reCAPTCHA and the Google <privacyLink>Privacy Policy</privacyLink> and <termsLink>Terms of Service</termsLink> apply.", "Este sitio est\xE1 protegido por reCAPTCHA y se aplican la <privacyLink>Pol\xEDtica de Privacidad</privacyLink> y los <termsLink>T\xE9rminos de Servicio</termsLink> de Google."]
};
var {
  useTranslation,
  Translation
} = createTranslationWithMessages(translationMessages, "auth.");

// src/errors.ts
var KnownErrorMessages = {
  "auth/popup-closed-by-user": "errors.popupClosedByUser",
  "auth/invalid-login-credentials": "errors.invalidLogin",
  "auth/email-already-in-use": "errors.emailAlreadyUsed",
  "auth/weak-password": "errors.weakPassword",
  "auth/invalid-phone-number": "errors.invalidPhone",
  "auth/missing-phone-number": "errors.invalidPhone",
  "auth/multi-factor-auth-required": "errors.mfaRequired",
  "auth/invalid-verification-code": "errors.invalidVerificationCode",
  "auth/second-factor-already-in-use": "errors.phoneAlreadyUsed",
  "auth/requires-recent-login": "errors.requiresRecentLogin",
  "auth/user-cancelled": "errors.userCancelled",
  "auth/popup-blocked": "errors.popupBlocked",
  "auth/user-token-expired": "errors.requiresRecentLogin",
  "auth/user-not-found": "errors.invalidLogin",
  "auth/wrong-password": "errors.invalidLogin",
  "auth/invalid-credential": "errors.invalidLogin",
  "auth/too-many-requests": "errors.tooManyRequests",
  "auth/code-expired": "errors.expiredVerificationCode",
  "auth/expired-action-code": "errors.expiredVerificationCode",
  "auth/invalid-action-code": "errors.expiredVerificationCode",
  "auth/network-request-failed": "errors.networkRequestFailed"
};
var getIsKnownError = (error) => {
  if (!error.code)
    return false;
  return !!KnownErrorMessages[error.code];
};
var getErrorTranslationKey = (error) => {
  if (!error.code)
    return null;
  return KnownErrorMessages[error.code] || null;
};
var useTranslateError = (error) => {
  const translation = useTranslation();
  if (!error)
    return null;
  const translationKey = getErrorTranslationKey(error);
  return translationKey ? translation({
    id: translationKey
  }) : error.message;
};
var useTranslationError = () => {
  const translation = useTranslation();
  return (error) => {
    const translationKey = getErrorTranslationKey(error);
    return translationKey ? translation({
      id: translationKey
    }) : error.message;
  };
};

// src/components/ButtonSignInWithGoogle.tsx
import styled2 from "styled-components";
import { font as font2, radius as radius2, theme as theme2, Flexer as Flexer2, Loadable } from "@taxfix/scouts-ui";
import { jsx as _jsx2, jsxs as _jsxs2 } from "react/jsx-runtime";
var ButtonSignInWithGoogle = ({
  onClick,
  disabled,
  isLoading
}) => /* @__PURE__ */ _jsx2(CustomButton, {
  disabled: disabled || isLoading,
  onClick,
  children: /* @__PURE__ */ _jsx2(Loadable, {
    isLoading,
    isSmall: true,
    shouldHideContentWhenLoading: true,
    spinnerColor: theme2.primary.main,
    spinnerColor2: theme2.common.disabled2,
    children: /* @__PURE__ */ _jsxs2(Flexer2, {
      gap: "10px",
      alignCenter: true,
      justifyCenter: true,
      children: [LogoGoogle, " ", /* @__PURE__ */ _jsx2(Translation, {
        id: "actions.signInWithGoogle"
      })]
    })
  })
});
var CustomButton = styled2.button.withConfig({
  displayName: "ButtonSignInWithGoogle__CustomButton",
  componentId: "sc-1lao7f4-0"
})(["color:", ";font-family:inherit;font-size:", ";font-weight:", ";line-height:1.3;text-decoration:none;white-space:nowrap;display:block;position:relative;width:100%;padding:10px;background:", ";border:2px solid ", ";border-radius:", ";cursor:pointer;"], theme2.text.title, font2.body.medium, font2.weight.medium, theme2.grey.background, theme2.grey.graphics1, radius2.small);
var LogoGoogle = /* @__PURE__ */ _jsxs2("svg", {
  viewBox: "0 0 533.5 544.3",
  height: "18px",
  children: [/* @__PURE__ */ _jsx2("path", {
    d: "M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z",
    fill: "#4285f4"
  }), /* @__PURE__ */ _jsx2("path", {
    d: "M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z",
    fill: "#34a853"
  }), /* @__PURE__ */ _jsx2("path", {
    d: "M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z",
    fill: "#fbbc04"
  }), /* @__PURE__ */ _jsx2("path", {
    d: "M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z",
    fill: "#ea4335"
  })]
});

// src/components/mfa-login/MfaChoiceForm.tsx
import { useState as useState5 } from "react";
import { useHistory } from "react-router-dom";
import { Button as Button3, ButtonLink, Flexer as Flexer5, Heading as Heading4, Line as Line3 } from "@taxfix/scouts-ui";

// src/helpers/decode-user-metadata.ts
var decodeUserMetadata = (encodedUserMetadata) => {
  try {
    return JSON.parse(decodeURIComponent(window.atob(encodedUserMetadata)));
  } catch {
    return null;
  }
};

// src/helpers/encode-user-metadata.ts
var encodeUserMetadata = (userMetadata) => {
  return window.btoa(encodeURIComponent(JSON.stringify(userMetadata)));
};

// src/helpers/get-is-password-leaked.ts
import { stringToSHA1Hash } from "@taxfix/scouts-helpers";
var getIsPasswordLeaked = async (password) => {
  const passwordHash = (await stringToSHA1Hash(password)).toUpperCase();
  const lookupHashPrefix = passwordHash.substring(0, 5);
  const restHash = passwordHash.substring(5);
  let response;
  try {
    response = await fetch(`https://api.pwnedpasswords.com/range/${lookupHashPrefix}`, {
      headers: {
        "Add-Padding": "true"
      }
    });
  } catch (error) {
    return {
      error
    };
  }
  if (!response.ok)
    return {
      error: new Error()
    };
  const body = await response.text();
  const matchingHashes = body.split("\r\n");
  for (const matchingHash of matchingHashes) {
    const [hash, occurrence] = matchingHash.split(":");
    if (occurrence === "0")
      return {
        data: false
      };
    if (hash === restHash)
      return {
        data: true
      };
  }
  return {
    data: false
  };
};

// src/helpers/get-token.ts
import { getAuth, getIdToken } from "firebase/auth";
var getToken = async () => {
  try {
    const user = getAuth().currentUser;
    if (!user)
      return null;
    return getIdToken(user);
  } catch {
    return null;
  }
};

// src/helpers/get-first-and-last-name-from-display-name.ts
var getFirstAndLastNameFromDisplayName = (displayName) => {
  const cleanDisplayName = (displayName || "").trim();
  if (!cleanDisplayName)
    return {};
  const idxLastSpace = cleanDisplayName.lastIndexOf(" ");
  if (idxLastSpace === -1) {
    return {
      firstName: displayName,
      lastName: ""
    };
  }
  const firstName = cleanDisplayName.substring(0, idxLastSpace);
  const lastName = cleanDisplayName.substring(idxLastSpace + 1);
  return {
    firstName,
    lastName
  };
};

// src/helpers/parse-user-metadata-from-hash.ts
var parseUserMetadataFromHash = (hash) => {
  const trimmedHash = hash.slice(6);
  if (!trimmedHash)
    return null;
  return decodeUserMetadata(trimmedHash);
};

// src/helpers/trigger-logout.ts
import { getAuth as getAuth2, signOut } from "firebase/auth";

// src/helpers/mfa-login/get-has-mfa.ts
import { PhoneMultiFactorGenerator, TotpMultiFactorGenerator } from "firebase/auth";
var buildGetHasMfa = (factorId) => ({
  resolver
}) => {
  return resolver.hints.some((i) => i.factorId === factorId);
};
var getHasTotpMfa = buildGetHasMfa(TotpMultiFactorGenerator.FACTOR_ID);
var getHasPhoneMfa = buildGetHasMfa(PhoneMultiFactorGenerator.FACTOR_ID);

// src/helpers/mfa-login/submit-totp-code.ts
import { TotpMultiFactorGenerator as TotpMultiFactorGenerator2 } from "firebase/auth";
var submitTotpCode = ({
  resolver,
  code
}) => {
  const multiFactorInfo = resolver.hints.find((i) => i.factorId === TotpMultiFactorGenerator2.FACTOR_ID);
  if (!multiFactorInfo)
    return;
  const multiFactorAssertion = TotpMultiFactorGenerator2.assertionForSignIn(multiFactorInfo.uid, code);
  return resolver.resolveSignIn(multiFactorAssertion);
};

// src/helpers/mfa-login/trigger-sms-code.ts
import { getAuth as getAuth3, PhoneAuthProvider } from "firebase/auth";
var triggerSmsSending = ({
  recaptchaVerifier,
  phoneInfoOptions
}) => {
  return new PhoneAuthProvider(getAuth3()).verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
};

// src/helpers/mfa-login/submit-sms-code.ts
import { PhoneAuthProvider as PhoneAuthProvider2, PhoneMultiFactorGenerator as PhoneMultiFactorGenerator2 } from "firebase/auth";
var submitSmsCode = ({
  code,
  resolver,
  verificationId
}) => {
  const cred = PhoneAuthProvider2.credential(verificationId, code);
  const multiFactorAssertion = PhoneMultiFactorGenerator2.assertion(cred);
  return resolver.resolveSignIn(multiFactorAssertion);
};

// src/components/mfa-login/MfaPhoneForm.tsx
import { PhoneMultiFactorGenerator as PhoneMultiFactorGenerator3 } from "firebase/auth";
import { useMemo, useState as useState3 } from "react";
import styled3 from "styled-components";
import { colors as colors2, font as font3, Button, Flexer as Flexer3, Form, Heading as Heading2, InlineLink, Input, Line, Notice, Paragraph, SelectWithLabel, Spacer as Spacer2 } from "@taxfix/scouts-ui";

// src/hooks/use-mfa-sms.ts
import { useState } from "react";
var useMfaSms = () => {
  const [verificationId, setVerificationId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const submitSmsCodeAction = (params) => {
    if (verificationId === null)
      return;
    setIsLoading(true);
    return submitSmsCode({
      ...params,
      verificationId
    }).catch((error2) => {
      setError(error2);
      return error2;
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const triggerSmsSendingAction = (params) => {
    setIsLoading(true);
    triggerSmsSending(params).then((id) => {
      setVerificationId(id);
      return id;
    }).catch((error2) => {
      setError(error2);
      return error2;
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    triggerSmsSendingAction,
    submitSmsCodeAction,
    isVerificationCodeSmsSent: verificationId !== null,
    isLoading,
    error
  };
};

// src/hooks/use-recaptcha.ts
import { getAuth as getAuth4, RecaptchaVerifier } from "firebase/auth";
import { useEffect, useRef, useState as useState2 } from "react";
var useRecaptcha = () => {
  const recaptchaVerifierRef = useRef();
  const [isRecaptchaReady, setIsRecaptchaReady] = useState2(false);
  const [isRecaptchaSolved, setIsRecaptchaSolved] = useState2(false);
  const initRecaptcha = (element) => {
    const auth = getAuth4();
    if (!auth)
      return;
    if (recaptchaVerifierRef.current)
      return;
    recaptchaVerifierRef.current = new RecaptchaVerifier(auth, element, {
      size: "invisible",
      callback: () => {
        setIsRecaptchaSolved(true);
      }
    });
    recaptchaVerifierRef.current.render().then(() => {
      setIsRecaptchaReady(true);
    });
  };
  useEffect(() => {
    return () => {
      if (recaptchaVerifierRef.current)
        recaptchaVerifierRef.current.clear();
    };
  }, []);
  const startRecaptchaVerification = () => {
    if (isRecaptchaSolved)
      return Promise.resolve(recaptchaVerifierRef.current);
    return recaptchaVerifierRef.current?.verify().then(() => recaptchaVerifierRef.current);
  };
  return {
    isRecaptchaReady,
    startRecaptchaVerification,
    initRecaptcha
  };
};

// src/components/mfa-login/MfaPhoneForm.tsx
import { jsx as _jsx3, jsxs as _jsxs3 } from "react/jsx-runtime";
var usePhoneFactorSelect = (phoneFactors) => {
  const [selectedPhoneFactorIndex, setSelectedPhoneFactorIndex] = useState3(0);
  const handlePhoneFactorChange = ({
    value
  }) => setSelectedPhoneFactorIndex(Number(value) || 0);
  const selectedPhoneFactor = phoneFactors[selectedPhoneFactorIndex];
  const {
    phoneNumber: selectedPhoneNumber
  } = selectedPhoneFactor;
  const phoneFactorOptions = useMemo(() => phoneFactors.map((phoneFactor, index) => ({
    value: index,
    title: phoneFactor.phoneNumber
  })), [phoneFactors]);
  return {
    handlePhoneFactorChange,
    phoneFactorOptions,
    selectedPhoneFactor,
    selectedPhoneFactorIndex,
    selectedPhoneNumber
  };
};
var MfaPhoneForm = ({
  resolver,
  onCancel,
  onSuccess
}) => {
  const [code, setCode] = useState3("");
  const {
    isRecaptchaReady,
    startRecaptchaVerification,
    initRecaptcha
  } = useRecaptcha();
  const {
    triggerSmsSendingAction,
    submitSmsCodeAction,
    isVerificationCodeSmsSent,
    isLoading,
    error
  } = useMfaSms();
  const errorMessage = useTranslateError(error);
  const translation = useTranslation();
  const phoneFactors = resolver.hints.filter((multiFactorInfo) => multiFactorInfo.factorId === PhoneMultiFactorGenerator3.FACTOR_ID);
  const {
    handlePhoneFactorChange,
    phoneFactorOptions,
    selectedPhoneFactor,
    selectedPhoneFactorIndex,
    selectedPhoneNumber
  } = usePhoneFactorSelect(phoneFactors);
  const hasMultiplePhoneFactors = phoneFactors.length > 1;
  const handleTriggerVerificationCodeSMS = () => {
    startRecaptchaVerification()?.then((recaptchaVerifier) => {
      if (!recaptchaVerifier)
        return;
      triggerSmsSendingAction({
        recaptchaVerifier,
        phoneInfoOptions: {
          multiFactorHint: selectedPhoneFactor,
          session: resolver?.session
        }
      });
    });
  };
  const handleChangeCode = ({
    value
  }) => {
    const regexNonDigit = /\D/gim;
    const valueWithNumbersOnly = value.replace(regexNonDigit, "");
    setCode(valueWithNumbersOnly);
  };
  const handleSubmitCode = () => {
    submitSmsCodeAction({
      code,
      resolver
    })?.then((response) => {
      if (response?.user)
        onSuccess();
    });
  };
  return /* @__PURE__ */ _jsxs3(Flexer3, {
    column: true,
    gap: "24px",
    children: [/* @__PURE__ */ _jsxs3(Flexer3, {
      column: true,
      gap: "6px",
      children: [/* @__PURE__ */ _jsx3(Heading2, {
        children: /* @__PURE__ */ _jsx3(Translation, {
          strings: ["Text message", "Text message"]
        })
      }), isVerificationCodeSmsSent && /* @__PURE__ */ _jsx3(Line, {
        children: /* @__PURE__ */ _jsx3(Translation, {
          strings: ["Enter the code you received via text message", "Introduce el c\xF3digo de verificaci\xF3n"]
        })
      })]
    }), !isVerificationCodeSmsSent && /* @__PURE__ */ _jsx3(Form, {
      onSubmit: handleTriggerVerificationCodeSMS,
      children: /* @__PURE__ */ _jsxs3(Flexer3, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [hasMultiplePhoneFactors && /* @__PURE__ */ _jsx3(SelectWithLabel, {
          isLarge: true,
          label: translation(["Select your phone number", "Selecciona tu n\xFAmero de tel\xE9fono"]),
          name: "phoneFactorIndex",
          onChange: handlePhoneFactorChange,
          options: phoneFactorOptions,
          value: selectedPhoneFactorIndex,
          width: "100%"
        }), /* @__PURE__ */ _jsx3(Paragraph, {
          children: /* @__PURE__ */ _jsx3(Translation, {
            id: "labels.sendSmsTo",
            values: {
              phone: selectedPhoneNumber || "_"
            }
          })
        }), /* @__PURE__ */ _jsxs3(Flexer3, {
          column: true,
          gap: "12px",
          children: [/* @__PURE__ */ _jsx3(Button, {
            type: "submit",
            size: "large",
            isFullWidth: true,
            isLoading,
            disabled: !isRecaptchaReady,
            children: /* @__PURE__ */ _jsx3(Translation, {
              id: "actions.continue"
            })
          }), /* @__PURE__ */ _jsx3(Button, {
            size: "large",
            variant: "tertiary",
            isFullWidth: true,
            onClick: onCancel,
            children: /* @__PURE__ */ _jsx3(Translation, {
              id: "actions.cancel"
            })
          })]
        })]
      })
    }), isVerificationCodeSmsSent && /* @__PURE__ */ _jsx3(Form, {
      onSubmit: handleSubmitCode,
      children: /* @__PURE__ */ _jsxs3(Flexer3, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [/* @__PURE__ */ _jsx3(Input, {
          autoComplete: "one-time-code",
          autoFocus: true,
          floatingLabel: translation({
            id: "labels.verificationCode"
          }),
          inputMode: "numeric",
          isLarge: true,
          minLength: 6,
          name: "code",
          onChange: handleChangeCode,
          required: true,
          shouldAlwaysDisplayFloatingLabel: true,
          value: code || ""
        }), errorMessage && /* @__PURE__ */ _jsx3(Notice, {
          children: errorMessage
        }), /* @__PURE__ */ _jsxs3(Flexer3, {
          column: true,
          gap: "12px",
          children: [/* @__PURE__ */ _jsx3(Button, {
            type: "submit",
            size: "large",
            isFullWidth: true,
            isLoading,
            children: /* @__PURE__ */ _jsx3(Translation, {
              id: "actions.continue"
            })
          }), /* @__PURE__ */ _jsx3(Button, {
            size: "large",
            variant: "tertiary",
            isFullWidth: true,
            onClick: onCancel,
            children: /* @__PURE__ */ _jsx3(Translation, {
              id: "actions.cancel"
            })
          })]
        })]
      })
    }), /* @__PURE__ */ _jsxs3(Spacer2, {
      children: [/* @__PURE__ */ _jsx3(Paragraph, {
        size: font3.tiny,
        color: colors2.text.neutral,
        alignCenter: true,
        children: /* @__PURE__ */ _jsx3(Translation, {
          id: "legal.recaptcha",
          values: {
            privacyLink: (chunks) => /* @__PURE__ */ _jsx3(InlineLink, {
              href: "https://policies.google.com/privacy",
              color: colors2.text.neutral,
              target: "_blank",
              rel: "noopener noreferrer",
              children: chunks
            }),
            termsLink: (chunks) => /* @__PURE__ */ _jsx3(InlineLink, {
              href: "https://policies.google.com/terms",
              color: colors2.text.neutral,
              target: "_blank",
              rel: "noopener noreferrer",
              children: chunks
            })
          }
        })
      }), /* @__PURE__ */ _jsx3(RecaptchaContainer, {
        ref: (element) => element && initRecaptcha(element)
      })]
    })]
  });
};
var RecaptchaContainer = styled3.div.withConfig({
  displayName: "MfaPhoneForm__RecaptchaContainer",
  componentId: "sc-jwitu8-0"
})(["overflow:hidden;height:1px;.grecaptcha-badge{position:relative !important;visibility:hidden;}"]);

// src/components/mfa-login/MfaTotpForm.tsx
import { useState as useState4 } from "react";
import { Button as Button2, Flexer as Flexer4, Form as Form2, Heading as Heading3, Input as Input2, Line as Line2, Notice as Notice2 } from "@taxfix/scouts-ui";
import { jsx as _jsx4, jsxs as _jsxs4 } from "react/jsx-runtime";
var MfaTotpForm = ({
  resolver,
  onCancel,
  onSuccess
}) => {
  const [code, setCode] = useState4("");
  const [isLoading, setIsLoading] = useState4(false);
  const [error, setError] = useState4(null);
  const errorMessage = useTranslateError(error);
  const translation = useTranslation();
  const handleChangeCode = ({
    value
  }) => {
    setError(null);
    setCode(value);
  };
  const handleSubmitCode = (submittedCode) => {
    setIsLoading(true);
    submitTotpCode({
      resolver,
      code: submittedCode.trim()
    })?.then((response) => {
      if (response?.user)
        onSuccess();
    })?.catch((error2) => {
      setError(error2);
    })?.finally(() => {
      setIsLoading(false);
    });
  };
  return /* @__PURE__ */ _jsxs4(Flexer4, {
    column: true,
    gap: "24px",
    children: [/* @__PURE__ */ _jsxs4(Flexer4, {
      column: true,
      gap: "6px",
      children: [/* @__PURE__ */ _jsx4(Heading3, {
        children: /* @__PURE__ */ _jsx4(Translation, {
          strings: ["Authenticator app", "App autenticador"]
        })
      }), /* @__PURE__ */ _jsx4(Line2, {
        children: /* @__PURE__ */ _jsx4(Translation, {
          strings: ["Enter the verification code from your authenticator app", "Introduce el c\xF3digo de verificaci\xF3n de tu app autenticador"]
        })
      })]
    }), /* @__PURE__ */ _jsx4(Form2, {
      onSubmit: () => handleSubmitCode(code),
      children: /* @__PURE__ */ _jsxs4(Flexer4, {
        column: true,
        gap: "18px",
        children: [/* @__PURE__ */ _jsx4(Input2, {
          autoComplete: "one-time-code",
          autoFocus: true,
          floatingLabel: translation({
            id: "labels.verificationCode"
          }),
          isLarge: true,
          name: "totp-code",
          onChange: handleChangeCode,
          required: true,
          shouldAlwaysDisplayFloatingLabel: true,
          value: code
        }), errorMessage && /* @__PURE__ */ _jsx4(Notice2, {
          children: errorMessage
        }), /* @__PURE__ */ _jsxs4(Flexer4, {
          column: true,
          gap: "12px",
          children: [/* @__PURE__ */ _jsx4(Button2, {
            type: "submit",
            size: "large",
            isFullWidth: true,
            isLoading,
            children: /* @__PURE__ */ _jsx4(Translation, {
              id: "actions.continue"
            })
          }), /* @__PURE__ */ _jsx4(Button2, {
            size: "large",
            variant: "tertiary",
            isFullWidth: true,
            onClick: onCancel,
            children: /* @__PURE__ */ _jsx4(Translation, {
              id: "actions.cancel"
            })
          })]
        })]
      })
    })]
  });
};

// src/components/mfa-login/MfaChoiceForm.tsx
import { jsx as _jsx5, jsxs as _jsxs5 } from "react/jsx-runtime";
var MfaChoiceForm = ({
  redirectPath,
  resolver,
  onCancel
}) => {
  const history = useHistory();
  const [selectedMfa, setSelectedMfa] = useState5(() => {
    const hasTotpMfa = getHasTotpMfa({
      resolver
    });
    const hasPhoneMfa = getHasPhoneMfa({
      resolver
    });
    if (hasTotpMfa && hasPhoneMfa)
      return null;
    if (hasTotpMfa)
      return "totp";
    return "phone";
  });
  const handleMfaSuccess = () => {
    if (redirectPath)
      history.push(redirectPath);
  };
  if (selectedMfa === null)
    return /* @__PURE__ */ _jsxs5(Flexer5, {
      column: true,
      gap: "24px",
      children: [/* @__PURE__ */ _jsxs5(Flexer5, {
        column: true,
        gap: "6px",
        children: [/* @__PURE__ */ _jsx5(Heading4, {
          children: /* @__PURE__ */ _jsx5(Translation, {
            strings: ["You have set up 2-step authentication", "Has configurado la autenticaci\xF3n de dos pasos"]
          })
        }), /* @__PURE__ */ _jsx5(Line3, {
          children: /* @__PURE__ */ _jsx5(Translation, {
            strings: ["Choose the preferred method to continue", "Elige el m\xE9todo preferido para continuar"]
          })
        })]
      }), /* @__PURE__ */ _jsxs5(Flexer5, {
        column: true,
        gap: "12px",
        children: [/* @__PURE__ */ _jsx5(Button3, {
          size: "large",
          onClick: () => setSelectedMfa("totp"),
          children: /* @__PURE__ */ _jsx5(Translation, {
            strings: ["Authenticator app", "App autenticador"]
          })
        }), /* @__PURE__ */ _jsx5(Button3, {
          size: "large",
          variant: "secondary",
          onClick: () => setSelectedMfa("phone"),
          children: /* @__PURE__ */ _jsx5(Translation, {
            strings: ["Text message", "Continuar con SMS"]
          })
        })]
      }), /* @__PURE__ */ _jsx5(Flexer5, {
        justifyCenter: true,
        children: /* @__PURE__ */ _jsx5(ButtonLink, {
          onClick: onCancel,
          children: /* @__PURE__ */ _jsx5(Translation, {
            id: "actions.cancel"
          })
        })
      })]
    });
  if (selectedMfa === "phone")
    return /* @__PURE__ */ _jsx5(MfaPhoneForm, {
      onSuccess: handleMfaSuccess,
      onCancel,
      resolver
    });
  return /* @__PURE__ */ _jsx5(MfaTotpForm, {
    onSuccess: handleMfaSuccess,
    onCancel,
    resolver
  });
};

// src/components/login-forms/LoginFormCompact.tsx
import { font as font4, Checkbox, ChipButton, Container as Container2, Flexer as Flexer6, Form as Form3, Input as Input3, Line as Line4, ModalLegacy as Modal, Notice as Notice3, Spacer as Spacer3 } from "@taxfix/scouts-ui";

// src/components/login-forms/use-login-form.ts
import { useState as useState9 } from "react";

// src/hooks/use-login.ts
import { browserSessionPersistence, getAuth as getAuth5, getMultiFactorResolver, indexedDBLocalPersistence, setPersistence, signInWithEmailAndPassword, AuthErrorCodes } from "firebase/auth";
import { useState as useState6 } from "react";
import { useHistory as useHistory2 } from "react-router-dom";

// src/config/ConfigContext.ts
import { createContext } from "react";
var ConfigContext = /* @__PURE__ */ createContext(null);

// src/config/ConfigProvider.tsx
import { jsx as _jsx6 } from "react/jsx-runtime";
var ConfigProvider = ({
  children,
  config
}) => /* @__PURE__ */ _jsx6(ConfigContext.Provider, {
  value: config,
  children
});

// src/config/use-config.ts
import { useContext } from "react";
var useConfig = () => {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error("`useConfig` must be used within a `ConfigContext.Provider`");
  }
  return config;
};

// src/hooks/use-login.ts
var useLogin = (setMfaResolver) => {
  const history = useHistory2();
  const {
    passwordLeakChecker,
    onLoginPasswordLeakChecked
  } = useConfig();
  const [isLoading, setIsLoading] = useState6(false);
  const [error, setError] = useState6(null);
  const login = ({
    email,
    password,
    shouldRememberMe,
    redirectPath
  }) => {
    const auth = getAuth5();
    if (!auth) {
      throw new Error("Firebase auth is not initialized");
    }
    setIsLoading(true);
    setError(null);
    if (onLoginPasswordLeakChecked)
      onLoginPasswordLeakChecked(false);
    const performPasswordLeakedCheck = () => {
      passwordLeakChecker(password).then((result) => {
        if (result.error)
          return;
        if (onLoginPasswordLeakChecked)
          onLoginPasswordLeakChecked(result.data);
      });
    };
    const persistenceType = shouldRememberMe ? indexedDBLocalPersistence : browserSessionPersistence;
    setPersistence(auth, persistenceType).then(() => signInWithEmailAndPassword(auth, email, password)).then((response) => {
      performPasswordLeakedCheck();
      if (redirectPath)
        history.push(redirectPath);
      return response;
    }).catch((error2) => {
      if (error2.code === AuthErrorCodes.MFA_REQUIRED) {
        performPasswordLeakedCheck();
        setMfaResolver(getMultiFactorResolver(auth, error2));
        return;
      }
      setError(error2);
      if (!getIsKnownError(error2))
        throw error2;
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    login,
    isLoading,
    error
  };
};

// src/hooks/use-mfa-resolver.ts
import { useCallback, useState as useState7 } from "react";
var useMfaResolver = () => {
  const [multifactorResolver, setMultifactorResolver] = useState7(null);
  const resetMfa = useCallback(() => {
    setMultifactorResolver(null);
  }, []);
  return {
    isMfaRequired: multifactorResolver !== null,
    multifactorResolver,
    setMultifactorResolver,
    resetMfa
  };
};

// src/hooks/use-signin-with-google.ts
import { browserSessionPersistence as browserSessionPersistence2, getAuth as getAuth6, getMultiFactorResolver as getMultiFactorResolver2, indexedDBLocalPersistence as indexedDBLocalPersistence2, setPersistence as setPersistence2, signInWithPopup, AuthErrorCodes as AuthErrorCodes2, GoogleAuthProvider } from "firebase/auth";
import { useCallback as useCallback2, useState as useState8 } from "react";
import { useHistory as useHistory3 } from "react-router-dom";
var provider = new GoogleAuthProvider();
var useSignInWithGoogle = (setMfaResolver) => {
  const translation = useTranslation();
  const history = useHistory3();
  const [isLoading, setIsLoading] = useState8(false);
  const [isNavigationPending, setIsNavigationPending] = useState8(false);
  const [error, setError] = useState8(null);
  const signInWithGoogle = useCallback2(({
    hasAgreedToTerms,
    hasAgreedToMarketingEmails,
    shouldRememberMe = false,
    redirectPath
  } = {}) => {
    const auth = getAuth6();
    if (!auth) {
      throw new Error("Firebase `auth` is not initialized");
    }
    if (hasAgreedToTerms === false) {
      setIsLoading(false);
      setError({
        message: translation({
          id: "errors.hasNotAgreedToTerms"
        })
      });
      return;
    }
    setIsLoading(true);
    setError(null);
    const persistenceType = shouldRememberMe ? indexedDBLocalPersistence2 : browserSessionPersistence2;
    setPersistence2(auth, persistenceType).then(() => signInWithPopup(auth, provider)).then((result) => {
      const user = result.user;
      if (!user) {
        throw new Error("No `user` returned from `signInWithPopup`");
      }
      const {
        firstName,
        lastName
      } = getFirstAndLastNameFromDisplayName(user.displayName || "");
      const userMetadata = {
        firstName,
        lastName
      };
      if (hasAgreedToMarketingEmails !== void 0) {
        userMetadata.hasAgreedToMarketingEmails = hasAgreedToMarketingEmails;
      }
      const encodedUserMetadata = encodeUserMetadata(userMetadata);
      const defaultRedirectPath = history.location.pathname;
      history.push(`${redirectPath ?? defaultRedirectPath}#meta=${encodedUserMetadata}`);
      setIsNavigationPending(true);
    }).catch((error2) => {
      setIsNavigationPending(false);
      if (error2.code === AuthErrorCodes2.MFA_REQUIRED && setMfaResolver) {
        setMfaResolver(getMultiFactorResolver2(auth, error2));
        return;
      }
      setError(error2);
      if (!getIsKnownError(error2))
        throw error2;
    }).finally(() => {
      setIsLoading(false);
    });
  }, [history, setMfaResolver, translation]);
  return {
    signInWithGoogle,
    isLoading: isLoading || isNavigationPending,
    error
  };
};

// src/components/login-forms/use-login-form.ts
var useLoginForm = () => {
  const {
    isMfaRequired,
    multifactorResolver,
    resetMfa,
    setMultifactorResolver
  } = useMfaResolver();
  const {
    login,
    isLoading: isLoadingLogin,
    error: errorLogin
  } = useLogin(setMultifactorResolver);
  const {
    signInWithGoogle,
    isLoading: isLoadingSignInWithGoogle,
    error: errorSignInWithGoogle
  } = useSignInWithGoogle(setMultifactorResolver);
  const [formState, setFormState] = useState9({
    email: "",
    password: "",
    rememberMe: true
  });
  const handleChange = ({
    name,
    value
  }) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };
  const isLoading = isLoadingLogin || isLoadingSignInWithGoogle;
  const error = errorLogin || errorSignInWithGoogle;
  const shouldDisplayMfaChoice = Boolean(isMfaRequired && multifactorResolver);
  return {
    formState,
    handleChange,
    login,
    signInWithGoogle,
    resetMfa,
    multifactorResolver,
    isLoading,
    error,
    shouldDisplayMfaChoice
  };
};

// src/components/login-forms/LoginFormCompact.tsx
import { jsx as _jsx7, jsxs as _jsxs6, Fragment as _Fragment } from "react/jsx-runtime";
var LoginFormCompact = ({
  redirectPath
}) => {
  const translation = useTranslation();
  const {
    formState,
    handleChange,
    login,
    signInWithGoogle,
    resetMfa,
    multifactorResolver,
    isLoading,
    error,
    shouldDisplayMfaChoice
  } = useLoginForm();
  const {
    email,
    password,
    rememberMe
  } = formState;
  const handleCheckboxChange = ({
    name,
    checked
  }) => handleChange({
    name,
    value: checked
  });
  const errorMessage = useTranslateError(error);
  return /* @__PURE__ */ _jsxs6(_Fragment, {
    children: [shouldDisplayMfaChoice && multifactorResolver && // Lower z-index to not overlap with the recaptcha challenge
    /* @__PURE__ */ _jsx7(Modal, {
      zIndex: 1e4,
      children: /* @__PURE__ */ _jsx7(Container2, {
        padding: "24px 24px 30px",
        tabletPadding: "30px 36px",
        children: /* @__PURE__ */ _jsx7(MfaChoiceForm, {
          onCancel: resetMfa,
          resolver: multifactorResolver
        })
      })
    }), /* @__PURE__ */ _jsx7(Form3, {
      onSubmit: () => login({
        email,
        password,
        shouldRememberMe: rememberMe,
        redirectPath
      }),
      children: /* @__PURE__ */ _jsxs6(Flexer6, {
        column: true,
        gap: "24px",
        children: [/* @__PURE__ */ _jsxs6(Flexer6, {
          column: true,
          gap: "18px",
          children: [/* @__PURE__ */ _jsxs6(Spacer3, {
            children: [/* @__PURE__ */ _jsx7(Title, {
              children: translation({
                id: "labels.email"
              })
            }), /* @__PURE__ */ _jsx7(Input3, {
              type: "email",
              name: "email",
              value: email,
              onChange: handleChange,
              autoComplete: "username",
              required: true
            })]
          }), /* @__PURE__ */ _jsxs6(Spacer3, {
            children: [/* @__PURE__ */ _jsx7(Title, {
              children: translation({
                id: "labels.password"
              })
            }), /* @__PURE__ */ _jsx7(Input3, {
              type: "password",
              name: "password",
              value: password,
              onChange: handleChange,
              autoComplete: "current-password",
              required: true
            })]
          })]
        }), /* @__PURE__ */ _jsx7(Spacer3, {
          children: /* @__PURE__ */ _jsx7(Checkbox, {
            checked: rememberMe,
            label: translation({
              id: "labels.rememberMe"
            }),
            name: "rememberMe",
            onChange: handleCheckboxChange
          })
        }), errorMessage && /* @__PURE__ */ _jsx7(Notice3, {
          children: errorMessage
        }), /* @__PURE__ */ _jsxs6(Flexer6, {
          column: true,
          gap: "12px",
          children: [/* @__PURE__ */ _jsx7(Spacer3, {
            children: /* @__PURE__ */ _jsx7(ChipButton, {
              type: "submit",
              size: "large",
              isFullWidth: true,
              isLoading,
              children: /* @__PURE__ */ _jsx7(Translation, {
                id: "actions.login"
              })
            })
          }), /* @__PURE__ */ _jsx7(Spacer3, {
            children: /* @__PURE__ */ _jsx7(ButtonSignInWithGoogle, {
              onClick: () => signInWithGoogle({
                shouldRememberMe: rememberMe,
                redirectPath
              }),
              disabled: isLoading,
              isLoading
            })
          })]
        })]
      })
    })]
  });
};
var Title = ({
  children
}) => /* @__PURE__ */ _jsx7(Spacer3, {
  marginBottom: "12px",
  children: /* @__PURE__ */ _jsx7(Line4, {
    size: font4.small,
    weight: font4.weight.medium,
    children
  })
});

// src/components/login-forms/LoginForm.tsx
import { jsx as _jsx8, jsxs as _jsxs7, Fragment as _Fragment2 } from "react/jsx-runtime";
var LoginForm = ({
  redirectPath
}) => {
  const isMobileAppMode = getIsMobileAppMode();
  const translation = useTranslation();
  const isTablet = useIsTablet();
  const {
    formState,
    handleChange,
    login,
    signInWithGoogle,
    resetMfa,
    multifactorResolver,
    isLoading,
    error,
    shouldDisplayMfaChoice
  } = useLoginForm();
  const {
    email,
    password,
    rememberMe
  } = formState;
  const handleCheckboxChange = ({
    name,
    checked
  }) => handleChange({
    name,
    value: checked
  });
  const errorMessage = useTranslateError(error);
  const shouldDisplaySignInWithGoogle = !isMobileAppMode;
  return /* @__PURE__ */ _jsxs7(_Fragment2, {
    children: [shouldDisplayMfaChoice && multifactorResolver && // Lower z-index to not overlap with the recaptcha challenge
    /* @__PURE__ */ _jsx8(Modal2, {
      zIndex: 1e4,
      children: /* @__PURE__ */ _jsx8(Container3, {
        padding: "24px 24px 30px",
        tabletPadding: "30px 36px",
        children: /* @__PURE__ */ _jsx8(MfaChoiceForm, {
          onCancel: resetMfa,
          resolver: multifactorResolver,
          redirectPath
        })
      })
    }), /* @__PURE__ */ _jsx8(Form4, {
      onSubmit: () => login({
        email,
        password,
        shouldRememberMe: rememberMe,
        redirectPath
      }),
      children: /* @__PURE__ */ _jsxs7(Flexer7, {
        column: true,
        gap: "24px",
        children: [/* @__PURE__ */ _jsxs7(Flexer7, {
          column: true,
          gap: "12px",
          tabletGap: "18px",
          children: [/* @__PURE__ */ _jsx8(Spacer4, {
            children: /* @__PURE__ */ _jsx8(Input4, {
              isLarge: true,
              floatingLabel: translation({
                id: "labels.email"
              }),
              type: "email",
              name: "email",
              value: email,
              onChange: handleChange,
              placeholder: translation({
                id: "labels.email"
              }),
              autoComplete: "username",
              required: true
            })
          }), /* @__PURE__ */ _jsx8(Spacer4, {
            children: /* @__PURE__ */ _jsx8(Input4, {
              isLarge: true,
              floatingLabel: translation({
                id: "labels.password"
              }),
              type: "password",
              name: "password",
              value: password,
              onChange: handleChange,
              placeholder: translation({
                id: "labels.password"
              }),
              autoComplete: "current-password",
              required: true
            })
          })]
        }), /* @__PURE__ */ _jsx8(Spacer4, {
          children: /* @__PURE__ */ _jsx8(Checkbox2, {
            checked: rememberMe,
            label: translation({
              id: "labels.rememberMe"
            }),
            name: "rememberMe",
            onChange: handleCheckboxChange,
            isSmall: !isTablet
          })
        }), errorMessage && /* @__PURE__ */ _jsx8(Notice4, {
          children: errorMessage
        }), /* @__PURE__ */ _jsxs7(Flexer7, {
          column: true,
          gap: "12px",
          children: [/* @__PURE__ */ _jsx8(Spacer4, {
            children: /* @__PURE__ */ _jsx8(Button4, {
              type: "submit",
              size: "large",
              isFullWidth: true,
              isLoading,
              children: /* @__PURE__ */ _jsx8(Translation, {
                id: "actions.login"
              })
            })
          }), shouldDisplaySignInWithGoogle && /* @__PURE__ */ _jsx8(Spacer4, {
            children: /* @__PURE__ */ _jsx8(ButtonSignInWithGoogle, {
              onClick: () => signInWithGoogle({
                shouldRememberMe: rememberMe,
                redirectPath
              }),
              disabled: isLoading,
              isLoading
            })
          })]
        })]
      })
    })]
  });
};
LoginForm.Compact = LoginFormCompact;

// src/helpers/mfa-management/get-has-enrolled-mfa.ts
import { multiFactor, PhoneMultiFactorGenerator as PhoneMultiFactorGenerator4, TotpMultiFactorGenerator as TotpMultiFactorGenerator3 } from "firebase/auth";
var getHasEnrolledMfa = (user) => {
  return multiFactor(user).enrolledFactors.length > 0;
};
var getHasEnrolledMultipleMfa = (user) => {
  return multiFactor(user).enrolledFactors.length > 1;
};
var getHasEnrolledPhone = (user) => {
  return multiFactor(user).enrolledFactors.some((factorInfo) => factorInfo.factorId === PhoneMultiFactorGenerator4.FACTOR_ID);
};
var getHasEnrolledTotp = (user) => {
  return multiFactor(user).enrolledFactors.some((factorInfo) => factorInfo.factorId === TotpMultiFactorGenerator3.FACTOR_ID);
};

// src/firebase/FirebaseContext.ts
import { createContext as createContext2 } from "react";
var FirebaseContext = /* @__PURE__ */ createContext2({
  isInitialized: false,
  user: null,
  hasUserEnrolledMfa: false
});

// src/firebase/use-initialize-firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth as getAuth7, onIdTokenChanged } from "firebase/auth";
import { useEffect as useEffect2, useState as useState10 } from "react";
import { useLocale } from "@taxfix/scouts-i18n";

// src/helpers/get-is-token-expired.ts
var getIsTokenExpired = async (firebaseUser, tokenDurationMilliseconds) => {
  if (!firebaseUser)
    return true;
  const tokenResult = await firebaseUser.getIdTokenResult();
  if (!tokenResult.token)
    return true;
  try {
    const authTimeMilliseconds = new Date(tokenResult.authTime).getTime();
    const authExpirationDate = new Date(authTimeMilliseconds + tokenDurationMilliseconds);
    return /* @__PURE__ */ new Date() >= authExpirationDate;
  } catch {
    return false;
  }
};

// src/firebase/use-app-check.ts
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { useCallback as useCallback3 } from "react";
var useAppCheck = () => {
  const initializeAppCheckWithRecaptcha = useCallback3((firebaseApp, recaptchaEnterpriseSiteKey) => {
    if (globalThis?.window === void 0)
      return;
    if (!recaptchaEnterpriseSiteKey)
      return;
    try {
      initializeAppCheck(firebaseApp, {
        provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseSiteKey),
        isTokenAutoRefreshEnabled: true
      });
    } catch {
    }
  }, []);
  return {
    initializeAppCheck: initializeAppCheckWithRecaptcha
  };
};

// src/firebase/use-initialize-firebase.ts
var hasFocus = () => typeof document !== "undefined" && document.hasFocus();
var useInitializeFirebase = () => {
  const config = useConfig();
  const locale = useLocale();
  const [isInitialized, setIsInitialized] = useState10(false);
  const [shouldInitialize, setShouldInitialize] = useState10(true);
  const [firebaseUser, setFirebaseUser] = useState10(null);
  const {
    initializeAppCheck: initializeAppCheck2
  } = useAppCheck();
  useEffect2(() => {
    if (!shouldInitialize)
      return;
    const firebaseApp = initializeApp({
      apiKey: config.firebaseApiKey,
      authDomain: config.firebaseAuthDomain,
      ...config.firebaseProjectId && {
        projectId: config.firebaseProjectId
      },
      ...config.firebaseAppId && {
        appId: config.firebaseAppId
      }
    });
    const auth = getAuth7(firebaseApp);
    auth.languageCode = locale;
    auth.tenantId = config.firebaseAuthTenantId;
    if (config.firebaseRecaptchaEnterpriseSiteKey)
      initializeAppCheck2(firebaseApp, config.firebaseRecaptchaEnterpriseSiteKey);
    setShouldInitialize(false);
  }, [config.firebaseApiKey, config.firebaseAppId, config.firebaseAuthDomain, config.firebaseAuthTenantId, config.firebaseProjectId, config.firebaseRecaptchaEnterpriseSiteKey, locale, shouldInitialize, initializeAppCheck2]);
  useEffect2(() => {
    if (shouldInitialize)
      return;
    const unsubscribe = onIdTokenChanged(getAuth7(), async (user) => {
      setTimeout(async () => {
        const isExpired = await getIsTokenExpired(user, config.tokenDurationMilliseconds);
        const firebaseUser2 = isExpired ? null : user;
        setFirebaseUser(firebaseUser2);
        setIsInitialized(true);
      }, hasFocus() ? 0 : 2e3);
    });
    return unsubscribe;
  }, [config.tokenDurationMilliseconds, shouldInitialize]);
  return {
    user: firebaseUser,
    isInitialized
  };
};

// src/firebase/FirebaseProvider.tsx
import { jsx as _jsx9 } from "react/jsx-runtime";
var FirebaseProvider = ({
  children
}) => {
  const {
    user,
    isInitialized
  } = useInitializeFirebase();
  const hasUserEnrolledMfa = !!user && getHasEnrolledMfa(user);
  return /* @__PURE__ */ _jsx9(FirebaseContext.Provider, {
    value: {
      user,
      isInitialized,
      hasUserEnrolledMfa
    },
    children
  });
};

// src/components/Provider.tsx
import { jsx as _jsx10 } from "react/jsx-runtime";
var Provider = ({
  children,
  config
}) => {
  return /* @__PURE__ */ _jsx10(ConfigProvider, {
    config,
    children: /* @__PURE__ */ _jsx10(FirebaseProvider, {
      children
    })
  });
};

// src/components/ResetPasswordForm.tsx
import { useState as useState12 } from "react";
import { colors as colors3, Button as Button5, Flexer as Flexer8, Form as Form5, Input as Input5, Notice as Notice5, Spacer as Spacer5 } from "@taxfix/scouts-ui";

// src/hooks/use-reset-password.ts
import { getAuth as getAuth8, sendPasswordResetEmail } from "firebase/auth";
import { useState as useState11 } from "react";
var useResetPassword = () => {
  const [isLoading, setIsLoading] = useState11(false);
  const [isSuccess, setIsSuccess] = useState11(false);
  const [error, setError] = useState11(null);
  const resetPassword = ({
    email
  }) => {
    const auth = getAuth8();
    if (!auth) {
      throw new Error("Firebase auth is not initialized");
    }
    setIsLoading(true);
    setError(null);
    sendPasswordResetEmail(auth, email).then(() => {
      setIsSuccess(true);
    }).catch((error2) => {
      setError(error2);
      setIsSuccess(false);
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    resetPassword,
    isLoading,
    error,
    isSuccess
  };
};

// src/components/ResetPasswordForm.tsx
import { jsx as _jsx11, jsxs as _jsxs8 } from "react/jsx-runtime";
var ResetPasswordForm = () => {
  const translation = useTranslation();
  const {
    resetPassword,
    isLoading,
    error,
    isSuccess
  } = useResetPassword();
  const errorMessage = useTranslateError(error);
  const [email, setEmail] = useState12("");
  return /* @__PURE__ */ _jsx11(Form5, {
    onSubmit: () => resetPassword({
      email
    }),
    children: /* @__PURE__ */ _jsxs8(Flexer8, {
      column: true,
      gap: "24px",
      children: [/* @__PURE__ */ _jsx11(Flexer8, {
        column: true,
        gap: "18px",
        children: /* @__PURE__ */ _jsx11(Spacer5, {
          children: /* @__PURE__ */ _jsx11(Input5, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.email"
            }),
            type: "email",
            name: "email",
            value: email,
            onChange: ({
              value
            }) => setEmail(value),
            placeholder: translation({
              id: "labels.email"
            }),
            autoComplete: "username",
            required: true
          })
        })
      }), errorMessage && /* @__PURE__ */ _jsx11(Notice5, {
        children: errorMessage
      }), isSuccess && /* @__PURE__ */ _jsx11(Notice5, {
        background: colors3.surface.affirm,
        children: /* @__PURE__ */ _jsx11(Translation, {
          id: "success.resetPasswordSent"
        })
      }), /* @__PURE__ */ _jsx11(Spacer5, {
        children: /* @__PURE__ */ _jsx11(Button5, {
          type: "submit",
          size: "large",
          isFullWidth: true,
          isLoading,
          children: /* @__PURE__ */ _jsx11(Translation, {
            id: "actions.resetPassword"
          })
        })
      })]
    })
  });
};

// src/components/signup-forms/SignupForm.tsx
import { getIsMobileAppMode as getIsMobileAppMode2 } from "@taxfix/scouts-helpers";
import { colors as colors6, font as font7, useIsTablet as useIsTablet3, Button as Button7, Checkbox as Checkbox5, Flexer as Flexer11, Form as Form8, Input as Input7, Notice as Notice8, Paragraph as Paragraph3, Spacer as Spacer8 } from "@taxfix/scouts-ui";

// src/components/signup-forms/SignupFormCompact.tsx
import { colors as colors4, font as font5, Button as Button6, Checkbox as Checkbox3, Flexer as Flexer9, Form as Form6, InlineLink as InlineLink2, Input as Input6, Line as Line5, Notice as Notice6, Spacer as Spacer6 } from "@taxfix/scouts-ui";

// src/components/signup-forms/use-signup-form.tsx
import { useMemo as useMemo2, useState as useState14 } from "react";
import { throttle } from "@taxfix/scouts-helpers";

// src/hooks/use-signup.ts
import { createUserWithEmailAndPassword, getAuth as getAuth9 } from "firebase/auth";
import { useState as useState13 } from "react";
import { useHistory as useHistory4 } from "react-router-dom";
var DEFAULT_REDIRECT_PATH = "/";
var useSignup = () => {
  const {
    passwordLeakChecker,
    onSignupPasswordLeakChecked,
    onLoginPasswordLeakChecked
  } = useConfig();
  const translation = useTranslation();
  const history = useHistory4();
  const [isLoading, setIsLoading] = useState13(false);
  const [error, setError] = useState13(null);
  const signup = async ({
    email,
    password,
    firstName,
    lastName,
    hasAgreedToTerms,
    hasAgreedToMarketingEmails,
    redirectPath = DEFAULT_REDIRECT_PATH
  }) => {
    const auth = getAuth9();
    if (!auth) {
      throw new Error("Firebase auth is not initialized");
    }
    if (isLoading)
      return;
    setIsLoading(true);
    setError(null);
    if (!email || !password || !firstName || !lastName) {
      setIsLoading(false);
      setError({
        message: translation({
          id: "errors.hasNotFilledAllFields"
        })
      });
      return;
    }
    if (!hasAgreedToTerms) {
      setIsLoading(false);
      setError({
        message: translation({
          id: "errors.hasNotAgreedToTerms"
        })
      });
      return;
    }
    if (onLoginPasswordLeakChecked)
      onLoginPasswordLeakChecked(false);
    let isPasswordLeaked = false;
    const passwordLeakedResponse = await passwordLeakChecker(password);
    if (!passwordLeakedResponse.error) {
      isPasswordLeaked = passwordLeakedResponse.data;
      if (onSignupPasswordLeakChecked)
        onSignupPasswordLeakChecked(passwordLeakedResponse.data);
    }
    if (isPasswordLeaked) {
      setIsLoading(false);
      setError({
        message: translation(["Please use a more secure password", "Por favor, usa una contrase\xF1a m\xE1s segura"])
      });
      return;
    }
    createUserWithEmailAndPassword(auth, email, password).then(() => {
      const encodedUserMetadata = encodeUserMetadata({
        firstName: (firstName || "").trim(),
        lastName: (lastName || "").trim(),
        hasAgreedToMarketingEmails
      });
      history.push(`${redirectPath}#meta=${encodedUserMetadata}`);
    }).catch((error2) => {
      setError(error2);
      setIsLoading(false);
      if (!getIsKnownError(error2))
        throw error2;
    });
  };
  return {
    signup,
    isLoading,
    error
  };
};

// src/components/signup-forms/use-signup-form.tsx
var useSignupForm = ({
  initialEmail,
  initialFirstName,
  initialLastName
} = {}) => {
  const {
    signup,
    isLoading: isLoadingSignup,
    error: errorSignup
  } = useSignup();
  const {
    signInWithGoogle,
    isLoading: isLoadingSignInWithGoogle,
    error: errorSignInWithGoogle
  } = useSignInWithGoogle();
  const [formState, setFormState] = useState14({
    email: initialEmail ?? "",
    password: "",
    firstName: initialFirstName ?? "",
    lastName: initialLastName ?? "",
    hasAgreedToTerms: false,
    hasAgreedToMarketingEmails: true
  });
  const handleChange = ({
    name,
    value
  }) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };
  const isLoading = isLoadingSignup || isLoadingSignInWithGoogle;
  const error = errorSignup || errorSignInWithGoogle;
  const signupThrottled = useMemo2(() => throttle(signup, 500, {
    leading: true,
    trailing: false
  }), [signup]);
  const signInWithGoogleThrottled = useMemo2(() => throttle(signInWithGoogle, 500, {
    leading: true,
    trailing: false
  }), [signInWithGoogle]);
  return {
    formState,
    handleChange,
    signup: signupThrottled,
    signInWithGoogle: signInWithGoogleThrottled,
    isLoading,
    error
  };
};

// src/components/signup-forms/SignupFormCompact.tsx
import { jsx as _jsx12, jsxs as _jsxs9 } from "react/jsx-runtime";
var SignupFormCompact = ({
  redirectPath
}) => {
  const config = useConfig();
  const translation = useTranslation();
  const {
    formState,
    handleChange,
    signup,
    signInWithGoogle,
    isLoading,
    error
  } = useSignupForm();
  const {
    email,
    password,
    firstName,
    lastName,
    hasAgreedToTerms,
    hasAgreedToMarketingEmails
  } = formState;
  const handleCheckboxChange = ({
    name,
    checked
  }) => {
    handleChange({
      name,
      value: checked
    });
  };
  const errorMessage = useTranslateError(error);
  return /* @__PURE__ */ _jsx12(Form6, {
    onSubmit: () => signup({
      email,
      password,
      firstName,
      lastName,
      hasAgreedToTerms,
      hasAgreedToMarketingEmails,
      redirectPath
    }),
    children: /* @__PURE__ */ _jsxs9(Flexer9, {
      column: true,
      gap: "24px",
      children: [/* @__PURE__ */ _jsxs9(Flexer9, {
        column: true,
        gap: "18px",
        children: [/* @__PURE__ */ _jsxs9(Flexer9, {
          column: true,
          tabletRow: true,
          gap: "18px",
          children: [/* @__PURE__ */ _jsxs9(Spacer6, {
            width: "100%",
            children: [/* @__PURE__ */ _jsx12(Title2, {
              children: translation({
                id: "labels.firstName"
              })
            }), /* @__PURE__ */ _jsx12(Input6, {
              name: "firstName",
              value: firstName,
              onChange: handleChange
            })]
          }), /* @__PURE__ */ _jsxs9(Spacer6, {
            width: "100%",
            children: [/* @__PURE__ */ _jsx12(Title2, {
              children: translation({
                id: "labels.lastName"
              })
            }), /* @__PURE__ */ _jsx12(Input6, {
              name: "lastName",
              value: lastName,
              onChange: handleChange
            })]
          })]
        }), /* @__PURE__ */ _jsxs9(Spacer6, {
          children: [/* @__PURE__ */ _jsx12(Title2, {
            children: translation({
              id: "labels.email"
            })
          }), /* @__PURE__ */ _jsx12(Input6, {
            type: "email",
            name: "email",
            value: email,
            onChange: handleChange,
            autoComplete: "username",
            required: true
          })]
        }), /* @__PURE__ */ _jsxs9(Spacer6, {
          children: [/* @__PURE__ */ _jsx12(Title2, {
            children: translation({
              id: "labels.choosePassword"
            })
          }), /* @__PURE__ */ _jsx12(Input6, {
            type: "password",
            name: "password",
            value: password,
            onChange: handleChange,
            autoComplete: "new-password",
            required: true
          })]
        })]
      }), /* @__PURE__ */ _jsxs9(Flexer9, {
        column: true,
        gap: "12px",
        children: [/* @__PURE__ */ _jsx12(Spacer6, {
          children: /* @__PURE__ */ _jsx12(Checkbox3, {
            isSmall: true,
            checked: hasAgreedToTerms,
            label: /* @__PURE__ */ _jsx12(Translation, {
              id: "labels.agreeToTerms",
              values: {
                termsLink: (chunks) => /* @__PURE__ */ _jsx12(InlineLink2, {
                  color: colors4.text.base,
                  href: config.termsUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: chunks
                }),
                privacyLink: (chunks) => /* @__PURE__ */ _jsx12(InlineLink2, {
                  color: colors4.text.base,
                  href: config.privacyUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: chunks
                })
              }
            }),
            name: "hasAgreedToTerms",
            onChange: handleCheckboxChange
          })
        }), /* @__PURE__ */ _jsx12(Spacer6, {
          children: /* @__PURE__ */ _jsx12(Checkbox3, {
            isSmall: true,
            checked: hasAgreedToMarketingEmails,
            label: translation({
              id: "labels.agreeToMarketingEmails"
            }),
            name: "hasAgreedToMarketingEmails",
            onChange: handleCheckboxChange
          })
        })]
      }), errorMessage && /* @__PURE__ */ _jsx12(Notice6, {
        children: errorMessage
      }), /* @__PURE__ */ _jsxs9(Flexer9, {
        column: true,
        gap: "12px",
        children: [/* @__PURE__ */ _jsx12(Spacer6, {
          children: /* @__PURE__ */ _jsx12(Button6, {
            type: "submit",
            size: "large",
            isFullWidth: true,
            isLoading,
            children: /* @__PURE__ */ _jsx12(Translation, {
              id: "actions.signup"
            })
          })
        }), /* @__PURE__ */ _jsx12(Flexer9, {
          justifyCenter: true,
          children: /* @__PURE__ */ _jsx12(ButtonSignInWithGoogle, {
            onClick: () => signInWithGoogle({
              hasAgreedToTerms,
              hasAgreedToMarketingEmails,
              redirectPath
            }),
            disabled: isLoading,
            isLoading
          })
        })]
      })]
    })
  });
};
var Title2 = ({
  children
}) => /* @__PURE__ */ _jsx12(Spacer6, {
  marginBottom: "12px",
  children: /* @__PURE__ */ _jsx12(Line5, {
    size: font5.small,
    weight: font5.weight.medium,
    children
  })
});

// src/components/signup-forms/SignupFormGoogle.tsx
import { useEffect as useEffect3 } from "react";
import { colors as colors5, font as font6, useIsTablet as useIsTablet2, Checkbox as Checkbox4, Flexer as Flexer10, Form as Form7, Notice as Notice7, Paragraph as Paragraph2, Spacer as Spacer7 } from "@taxfix/scouts-ui";

// src/components/signup-forms/use-signup-form-google.tsx
import { useState as useState15 } from "react";
var useSignupFormGoogle = () => {
  const {
    isMfaRequired,
    multifactorResolver,
    resetMfa,
    setMultifactorResolver
  } = useMfaResolver();
  const {
    signInWithGoogle,
    isLoading: isLoadingSignInWithGoogle,
    error: errorSignInWithGoogle
  } = useSignInWithGoogle(setMultifactorResolver);
  const [formState, setFormState] = useState15({
    hasAgreedToTerms: false,
    hasAgreedToMarketingEmails: true
  });
  const handleChange = ({
    name,
    value
  }) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleCheckboxChange = ({
    name,
    checked
  }) => {
    handleChange({
      name,
      value: checked
    });
  };
  const isLoading = isLoadingSignInWithGoogle;
  const error = errorSignInWithGoogle;
  const shouldDisplayMfaChoice = Boolean(isMfaRequired && multifactorResolver);
  return {
    formState,
    handleChange,
    handleCheckboxChange,
    signInWithGoogle,
    resetMfa,
    multifactorResolver,
    isLoading,
    error,
    shouldDisplayMfaChoice
  };
};

// src/components/signup-forms/SignupFormGoogle.tsx
import { jsx as _jsx13, jsxs as _jsxs10 } from "react/jsx-runtime";
var SignupFormGoogle = ({
  redirectPath
}) => {
  const config = useConfig();
  const translation = useTranslation();
  const isTablet = useIsTablet2();
  const {
    formState,
    handleCheckboxChange,
    signInWithGoogle,
    resetMfa,
    multifactorResolver,
    isLoading,
    error,
    shouldDisplayMfaChoice
  } = useSignupFormGoogle();
  const {
    hasAgreedToTerms,
    hasAgreedToMarketingEmails
  } = formState;
  const errorMessage = useTranslateError(error);
  const termsLinkRenderer = (chunks) => /* @__PURE__ */ _jsx13("a", {
    href: config.termsUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: chunks
  });
  const privacyLinkRenderer = (chunks) => /* @__PURE__ */ _jsx13("a", {
    href: config.privacyUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: chunks
  });
  useEffect3(() => {
    signInWithGoogle({
      hasAgreedToTerms,
      hasAgreedToMarketingEmails,
      redirectPath
    });
  }, [hasAgreedToMarketingEmails, hasAgreedToTerms, redirectPath, signInWithGoogle]);
  if (shouldDisplayMfaChoice && multifactorResolver) {
    return /* @__PURE__ */ _jsx13(Flexer10, {
      column: true,
      gap: "24px",
      children: /* @__PURE__ */ _jsx13(MfaChoiceForm, {
        onCancel: resetMfa,
        resolver: multifactorResolver,
        redirectPath
      })
    });
  }
  return /* @__PURE__ */ _jsx13(Form7, {
    onSubmit: () => {
    },
    children: /* @__PURE__ */ _jsxs10(Flexer10, {
      column: true,
      gap: "24px",
      children: [errorMessage && /* @__PURE__ */ _jsx13(Notice7, {
        children: errorMessage
      }), /* @__PURE__ */ _jsx13(Flexer10, {
        justifyCenter: true,
        children: /* @__PURE__ */ _jsx13(ButtonSignInWithGoogle, {
          onClick: () => signInWithGoogle({
            hasAgreedToTerms,
            hasAgreedToMarketingEmails,
            redirectPath
          }),
          isLoading,
          disabled: isLoading
        })
      }), /* @__PURE__ */ _jsxs10(Flexer10, {
        column: true,
        gap: "12px",
        children: [/* @__PURE__ */ _jsx13(Spacer7, {
          children: /* @__PURE__ */ _jsx13(Checkbox4, {
            checked: hasAgreedToTerms,
            label: /* @__PURE__ */ _jsx13(Translation, {
              id: "labels.agreeToTerms",
              values: {
                termsLink: termsLinkRenderer,
                privacyLink: privacyLinkRenderer
              }
            }),
            name: "hasAgreedToTerms",
            onChange: handleCheckboxChange,
            isSmall: !isTablet
          })
        }), /* @__PURE__ */ _jsxs10(Spacer7, {
          children: [/* @__PURE__ */ _jsx13(Checkbox4, {
            checked: hasAgreedToMarketingEmails,
            label: translation({
              id: "labels.agreeToMarketingEmails"
            }),
            name: "hasAgreedToMarketingEmails",
            onChange: handleCheckboxChange,
            isSmall: !isTablet
          }), isTablet && /* @__PURE__ */ _jsx13(Spacer7, {
            marginTop: "12px",
            children: /* @__PURE__ */ _jsx13(Paragraph2, {
              size: font6.smaller,
              color: colors5.text.neutral,
              children: /* @__PURE__ */ _jsx13(Translation, {
                id: "labels.agreeToMarketingEmailsDetails"
              })
            })
          })]
        })]
      })]
    })
  });
};

// src/components/signup-forms/SignupForm.tsx
import { jsx as _jsx14, jsxs as _jsxs11 } from "react/jsx-runtime";
var SignupForm = ({
  initialEmail,
  redirectPath
}) => {
  const isMobileAppMode = getIsMobileAppMode2();
  const config = useConfig();
  const translation = useTranslation();
  const isTablet = useIsTablet3();
  const {
    formState,
    handleChange,
    signup,
    signInWithGoogle,
    isLoading,
    error
  } = useSignupForm({
    initialEmail
  });
  const {
    email,
    password,
    firstName,
    lastName,
    hasAgreedToTerms,
    hasAgreedToMarketingEmails
  } = formState;
  const handleCheckboxChange = ({
    name,
    checked
  }) => {
    handleChange({
      name,
      value: checked
    });
  };
  const errorMessage = useTranslateError(error);
  const termsLinkRenderer = (chunks) => /* @__PURE__ */ _jsx14("a", {
    href: config.termsUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: chunks
  });
  const privacyLinkRenderer = (chunks) => /* @__PURE__ */ _jsx14("a", {
    href: config.privacyUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: chunks
  });
  return /* @__PURE__ */ _jsx14(Form8, {
    onSubmit: () => signup({
      email,
      password,
      firstName,
      lastName,
      hasAgreedToTerms,
      hasAgreedToMarketingEmails,
      redirectPath
    }),
    children: /* @__PURE__ */ _jsxs11(Flexer11, {
      column: true,
      gap: "24px",
      children: [/* @__PURE__ */ _jsxs11(Flexer11, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [/* @__PURE__ */ _jsx14(Spacer8, {
          children: /* @__PURE__ */ _jsx14(Input7, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.email"
            }),
            type: "email",
            name: "email",
            value: email,
            onChange: handleChange,
            placeholder: translation({
              id: "labels.email"
            }),
            autoComplete: "username",
            required: true
          })
        }), /* @__PURE__ */ _jsx14(Spacer8, {
          children: /* @__PURE__ */ _jsx14(Input7, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.choosePassword"
            }),
            type: "password",
            name: "password",
            value: password,
            onChange: handleChange,
            placeholder: translation({
              id: "labels.choosePassword"
            }),
            autoComplete: "new-password",
            required: true
          })
        }), /* @__PURE__ */ _jsx14(Spacer8, {
          children: /* @__PURE__ */ _jsx14(Input7, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.firstName"
            }),
            name: "firstName",
            value: firstName,
            onChange: handleChange,
            placeholder: translation({
              id: "labels.firstName"
            })
          })
        }), /* @__PURE__ */ _jsx14(Spacer8, {
          children: /* @__PURE__ */ _jsx14(Input7, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.lastName"
            }),
            name: "lastName",
            value: lastName,
            onChange: handleChange,
            placeholder: translation({
              id: "labels.lastName"
            })
          })
        })]
      }), /* @__PURE__ */ _jsxs11(Flexer11, {
        column: true,
        gap: "12px",
        children: [/* @__PURE__ */ _jsx14(Spacer8, {
          children: /* @__PURE__ */ _jsx14(Checkbox5, {
            checked: hasAgreedToTerms,
            label: /* @__PURE__ */ _jsx14(Translation, {
              id: "labels.agreeToTerms",
              values: {
                termsLink: termsLinkRenderer,
                privacyLink: privacyLinkRenderer
              }
            }),
            name: "hasAgreedToTerms",
            onChange: handleCheckboxChange,
            isSmall: !isTablet
          })
        }), /* @__PURE__ */ _jsxs11(Spacer8, {
          children: [/* @__PURE__ */ _jsx14(Checkbox5, {
            checked: hasAgreedToMarketingEmails,
            label: translation({
              id: "labels.agreeToMarketingEmails"
            }),
            name: "hasAgreedToMarketingEmails",
            onChange: handleCheckboxChange,
            isSmall: !isTablet
          }), isTablet && /* @__PURE__ */ _jsx14(Spacer8, {
            marginTop: "12px",
            children: /* @__PURE__ */ _jsx14(Paragraph3, {
              size: font7.smaller,
              color: colors6.text.neutral,
              children: /* @__PURE__ */ _jsx14(Translation, {
                id: "labels.agreeToMarketingEmailsDetails"
              })
            })
          })]
        })]
      }), errorMessage && /* @__PURE__ */ _jsx14(Notice8, {
        children: errorMessage
      }), /* @__PURE__ */ _jsxs11(Flexer11, {
        column: true,
        gap: "12px",
        children: [/* @__PURE__ */ _jsx14(Spacer8, {
          children: /* @__PURE__ */ _jsx14(Button7, {
            type: "submit",
            size: "large",
            isFullWidth: true,
            isLoading,
            children: /* @__PURE__ */ _jsx14(Translation, {
              id: "actions.signup"
            })
          })
        }), !isMobileAppMode && /* @__PURE__ */ _jsx14(Flexer11, {
          justifyCenter: true,
          children: /* @__PURE__ */ _jsx14(ButtonSignInWithGoogle, {
            onClick: () => signInWithGoogle({
              hasAgreedToTerms,
              hasAgreedToMarketingEmails,
              redirectPath
            }),
            disabled: isLoading,
            isLoading
          })
        })]
      })]
    })
  });
};
SignupForm.Compact = SignupFormCompact;
SignupForm.Google = SignupFormGoogle;

// src/components/auth-modal/AuthModal.tsx
import { useHistory as useHistory5, useLocation } from "react-router-dom";
import { font as font8, ButtonLink as ButtonLink2, Container as Container4, Flexer as Flexer12, Heading as Heading5, ModalLegacy as Modal3, Spacer as Spacer9 } from "@taxfix/scouts-ui";

// src/paths.ts
var PATH_ROOT = "/";
var PATH_MFA_ENROLL_PHONE = "/mfa-enroll-phone";
var PATH_MFA_ENROLL_TOTP = "/mfa-enroll-totp";
var PATH_MFA_ENFORCER = "/mfa-enforcer";

// src/components/auth-modal/AuthModal.tsx
import { jsx as _jsx15, jsxs as _jsxs12, Fragment as _Fragment3 } from "react/jsx-runtime";
var AuthModalHash = {
  signup: "signup",
  login: "login",
  forgot: "forgot"
};
var AuthModal = ({
  onClose,
  redirectPath
}) => {
  const history = useHistory5();
  const location = useLocation();
  const isActiveHashSignup = !location.hash || location.hash === `#${AuthModalHash.signup}`;
  const isActiveHashLogin = location.hash === `#${AuthModalHash.login}`;
  const isActiveHashForgotPassword = location.hash === `#${AuthModalHash.forgot}`;
  const path = redirectPath || PATH_ROOT;
  return (
    // Lower z-index to not overlap with the mfa modal
    /* @__PURE__ */ _jsx15(Modal3, {
      onClose,
      zIndex: 9999,
      children: /* @__PURE__ */ _jsx15(Container4, {
        padding: "24px 18px 24px",
        tabletPadding: "30px 36px",
        children: /* @__PURE__ */ _jsxs12(Flexer12, {
          column: true,
          gap: "24px",
          tabletGap: "30px",
          children: [/* @__PURE__ */ _jsxs12(Heading5, {
            weight: font8.weight.medium,
            size: font8.normal,
            tabletSize: font8.large,
            textAlign: "center",
            children: [isActiveHashLogin && /* @__PURE__ */ _jsx15(Translation, {
              strings: ["Log in to Taxfix", "Inicia sesi\xF3n"]
            }), isActiveHashSignup && /* @__PURE__ */ _jsx15(Translation, {
              strings: ["Let's get started", "Empecemos por crear tu cuenta"]
            }), isActiveHashForgotPassword && /* @__PURE__ */ _jsx15(Translation, {
              strings: ["Reset your password", "Restaura tu contrase\xF1a"]
            })]
          }), /* @__PURE__ */ _jsxs12(Spacer9, {
            children: [isActiveHashSignup && /* @__PURE__ */ _jsx15(Auth.SignupForm, {
              redirectPath: path
            }), isActiveHashLogin && /* @__PURE__ */ _jsx15(Auth.LoginForm, {
              redirectPath: path
            }), isActiveHashForgotPassword && /* @__PURE__ */ _jsx15(Auth.ResetPasswordForm, {})]
          }), /* @__PURE__ */ _jsxs12(Flexer12, {
            gap: "12px",
            justifyCenter: true,
            alignCenter: true,
            column: true,
            children: [isActiveHashSignup && /* @__PURE__ */ _jsxs12(ButtonLink2, {
              onClick: () => history.push({
                hash: AuthModalHash.login
              }),
              children: [/* @__PURE__ */ _jsx15(Translation, {
                strings: ["Already have an account?", "\xBFYa tienes una cuenta?"]
              }), " ", /* @__PURE__ */ _jsx15(Translation, {
                strings: ["Log in here", "Inicia sesi\xF3n"]
              })]
            }), isActiveHashLogin && /* @__PURE__ */ _jsxs12(_Fragment3, {
              children: [/* @__PURE__ */ _jsxs12(ButtonLink2, {
                onClick: () => history.push({
                  hash: AuthModalHash.signup
                }),
                children: [/* @__PURE__ */ _jsx15(Translation, {
                  strings: ["Don\u2019t have an account?", "\xBFNo tienes cuenta?"]
                }), " ", /* @__PURE__ */ _jsx15(Translation, {
                  strings: ["Sign up here", "Reg\xEDstrate"]
                })]
              }), /* @__PURE__ */ _jsxs12(ButtonLink2, {
                onClick: () => history.push({
                  hash: AuthModalHash.forgot
                }),
                children: [/* @__PURE__ */ _jsx15(Translation, {
                  strings: ["Forgot password?", "\xBFHas olvidado tu contrase\xF1a?"]
                }), " ", /* @__PURE__ */ _jsx15(Translation, {
                  strings: ["Reset password", "Rest\xE1urala"]
                })]
              })]
            }), isActiveHashForgotPassword && /* @__PURE__ */ _jsx15(ButtonLink2, {
              onClick: () => history.push({
                hash: AuthModalHash.login
              }),
              children: /* @__PURE__ */ _jsx15(Translation, {
                strings: ["Back", "Atr\xE1s"]
              })
            })]
          })]
        })
      })
    })
  );
};

// src/components/management/AuthManagement.tsx
import { Flexer as Flexer22 } from "@taxfix/scouts-ui";

// src/components/management/ChangePassword.tsx
import { useToggle } from "@taxfix/scouts-helpers";
import { colors as colors7, radius as radius3, Button as Button9, Container as Container5, Flexer as Flexer13, Heading as Heading6, Spacer as Spacer10 } from "@taxfix/scouts-ui";

// src/firebase/use-firebase.ts
import { useContext as useContext2 } from "react";
var useFirebase = () => {
  const firebase = useContext2(FirebaseContext);
  return firebase;
};

// src/helpers/get-is-password-login.ts
import { EmailAuthProvider } from "firebase/auth";
var getIsPasswordLogin = (user) => {
  return user.providerData.some((userInfo) => userInfo.providerId === EmailAuthProvider.PROVIDER_ID);
};

// src/components/management/ChangePasswordModal.tsx
import { Button as Button8, ModalActionsLegacy as ModalActions, ModalBodyLegacy as ModalBody, ModalFooterLegacy as ModalFooter, ModalHeaderLegacy as ModalHeader, ModalLegacy as Modal4, ModalTitleLegacy as ModalTitle, Paragraph as Paragraph4 } from "@taxfix/scouts-ui";
import { jsx as _jsx16, Fragment as _Fragment4, jsxs as _jsxs13 } from "react/jsx-runtime";
var ChangePasswordModal = ({
  onClose
}) => {
  const {
    user
  } = useFirebase();
  const {
    isLoading,
    error,
    isSuccess,
    resetPassword
  } = useResetPassword();
  const errorMessage = useTranslateError(error);
  const handleSendEmail = () => {
    if (!user?.email)
      return;
    resetPassword({
      email: user.email
    });
  };
  return /* @__PURE__ */ _jsxs13(Modal4, {
    onClose,
    children: [/* @__PURE__ */ _jsx16(ModalHeader, {
      children: /* @__PURE__ */ _jsx16(ModalTitle, {
        children: /* @__PURE__ */ _jsx16(Translation, {
          strings: ["Password reset email", "Cambia tu contrase\xF1a"]
        })
      })
    }), /* @__PURE__ */ _jsx16(ModalBody, {
      children: /* @__PURE__ */ _jsxs13(Paragraph4, {
        children: [!isSuccess && !error && /* @__PURE__ */ _jsx16(Translation, {
          strings: ["To change your password, we'll send you an email with a link to set your new password", "Enviar email de cambio de contrase\xF1a"]
        }), isSuccess && /* @__PURE__ */ _jsx16(Translation, {
          strings: ["Password reset email successfully sent", "Email de cambio de contrase\xF1a enviado correctamente"]
        }), errorMessage && /* @__PURE__ */ _jsx16(_Fragment4, {
          children: errorMessage
        })]
      })
    }), /* @__PURE__ */ _jsx16(ModalFooter, {
      children: /* @__PURE__ */ _jsxs13(ModalActions, {
        children: [!isSuccess && /* @__PURE__ */ _jsxs13(_Fragment4, {
          children: [/* @__PURE__ */ _jsx16(Button8, {
            variant: "tertiary",
            size: "large",
            onClick: onClose,
            children: /* @__PURE__ */ _jsx16(Translation, {
              id: "actions.cancel"
            })
          }), /* @__PURE__ */ _jsx16(Button8, {
            onClick: handleSendEmail,
            isLoading,
            size: "large",
            children: /* @__PURE__ */ _jsx16(Translation, {
              strings: ["Send", "Enviar"]
            })
          })]
        }), isSuccess && /* @__PURE__ */ _jsx16(Button8, {
          onClick: onClose,
          size: "large",
          children: /* @__PURE__ */ _jsx16(Translation, {
            id: "actions.close"
          })
        })]
      })
    })]
  });
};

// src/components/management/ChangePassword.tsx
import { jsx as _jsx17, jsxs as _jsxs14, Fragment as _Fragment5 } from "react/jsx-runtime";
var ChangePassword = () => {
  const {
    user
  } = useFirebase();
  const [isModalOpen, openModal, closeModal] = useToggle(false);
  if (!user || !getIsPasswordLogin(user))
    return null;
  return /* @__PURE__ */ _jsxs14(_Fragment5, {
    children: [/* @__PURE__ */ _jsx17(Container5, {
      radius: radius3.large,
      border: `1px solid ${colors7.line.neutralSoft}`,
      padding: "12px 18px",
      tabletPadding: "24px 36px",
      children: /* @__PURE__ */ _jsxs14(Flexer13, {
        column: true,
        tabletRow: true,
        gap: "9px",
        tabletGap: "24px",
        tabletAlignCenter: true,
        spaceBetween: true,
        children: [/* @__PURE__ */ _jsxs14(Heading6, {
          children: ["\u{1F511}\xA0 ", /* @__PURE__ */ _jsx17(Translation, {
            strings: ["Change password", "Cambia tu contrase\xF1a"]
          })]
        }), /* @__PURE__ */ _jsx17(Spacer10, {
          flex: "0 1 auto",
          children: /* @__PURE__ */ _jsx17(Button9, {
            variant: "secondary",
            onClick: openModal,
            children: /* @__PURE__ */ _jsx17(Translation, {
              strings: ["Send password reset email", "Cambiar contrase\xF1a"]
            })
          })
        })]
      })
    }), isModalOpen && /* @__PURE__ */ _jsx17(ChangePasswordModal, {
      onClose: closeModal
    })]
  });
};

// src/components/management/link-auth/LinkEmailPassword.tsx
import { useToggle as useToggle2 } from "@taxfix/scouts-helpers";
import { colors as colors8, radius as radius4, ChipButton as ChipButton2, Container as Container6, Flexer as Flexer15, Heading as Heading7, Paragraph as Paragraph6, Spacer as Spacer12 } from "@taxfix/scouts-ui";

// src/components/management/link-auth/LinkEmailPasswordModal.tsx
import { useState as useState16 } from "react";
import { addSuccessToast, font as font9, Button as Button10, Flexer as Flexer14, Form as Form9, Input as Input8, Line as Line6, ModalActionsLegacy as ModalActions2, ModalBodyLegacy as ModalBody2, ModalFooterLegacy as ModalFooter2, ModalHeaderLegacy as ModalHeader2, ModalLegacy as Modal5, ModalTitleLegacy as ModalTitle2, Notice as Notice9, Paragraph as Paragraph5, Spacer as Spacer11 } from "@taxfix/scouts-ui";

// src/helpers/link-email-password.ts
import { getAuth as getAuth10, linkWithCredential, EmailAuthProvider as EmailAuthProvider2 } from "firebase/auth";
var linkEmailPassword = async ({
  email,
  password
}) => {
  const credential = EmailAuthProvider2.credential(email, password);
  const auth = getAuth10();
  if (!auth.currentUser)
    return {
      error: {
        message: ""
      }
    };
  try {
    const userCredential = await linkWithCredential(auth.currentUser, credential);
    return {
      data: userCredential
    };
  } catch (error) {
    return {
      error
    };
  }
};

// src/components/management/link-auth/LinkEmailPasswordModal.tsx
import { jsx as _jsx18, jsxs as _jsxs15 } from "react/jsx-runtime";
var LinkEmailPasswordModal = ({
  onClose
}) => {
  const {
    passwordLeakChecker,
    onEmailChanged
  } = useConfig();
  const translation = useTranslation();
  const [formState, setFormState] = useState16({
    email: "",
    password: ""
  });
  const [isLoading, setIsLoading] = useState16(false);
  const [error, setError] = useState16(null);
  const errorMessage = useTranslateError(error);
  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.name]: e.value
    });
  };
  const handleSubmit = async ({
    email,
    password
  }) => {
    setIsLoading(true);
    setError(null);
    const passwordLeakResult = await passwordLeakChecker(password);
    if (passwordLeakResult.data) {
      setError({
        message: translation({
          id: "errors.weakPassword"
        })
      });
      setIsLoading(false);
      return;
    }
    const result = await linkEmailPassword({
      email,
      password
    });
    setIsLoading(false);
    if (result.error) {
      setError(result.error);
      return;
    }
    if (onEmailChanged)
      onEmailChanged(result.data.user.email ?? "");
    addSuccessToast({
      body: translation(["Email changed", "Email cambiado"])
    });
    onClose();
  };
  return /* @__PURE__ */ _jsx18(Modal5, {
    onClose: isLoading ? void 0 : onClose,
    children: /* @__PURE__ */ _jsxs15(Form9, {
      onSubmit: () => {
        handleSubmit(formState);
      },
      children: [/* @__PURE__ */ _jsx18(ModalHeader2, {
        children: /* @__PURE__ */ _jsx18(ModalTitle2, {
          children: /* @__PURE__ */ _jsx18(Translation, {
            strings: ["Change email", "Cambiar email"]
          })
        })
      }), /* @__PURE__ */ _jsx18(ModalBody2, {
        children: /* @__PURE__ */ _jsxs15(Flexer14, {
          column: true,
          gap: "18px",
          children: [/* @__PURE__ */ _jsxs15(Spacer11, {
            children: [/* @__PURE__ */ _jsx18(Title3, {
              children: translation({
                id: "labels.email"
              })
            }), /* @__PURE__ */ _jsx18(Input8, {
              type: "email",
              name: "email",
              value: formState.email,
              onChange: handleChange,
              autoComplete: "username",
              required: true
            })]
          }), /* @__PURE__ */ _jsxs15(Spacer11, {
            children: [/* @__PURE__ */ _jsx18(Title3, {
              children: translation({
                id: "labels.choosePassword"
              })
            }), /* @__PURE__ */ _jsx18(Input8, {
              type: "password",
              name: "password",
              value: formState.password,
              onChange: handleChange,
              autoComplete: "new-password",
              required: true
            })]
          }), errorMessage && /* @__PURE__ */ _jsx18(Notice9, {
            children: /* @__PURE__ */ _jsx18(Paragraph5, {
              children: errorMessage
            })
          })]
        })
      }), /* @__PURE__ */ _jsx18(ModalFooter2, {
        children: /* @__PURE__ */ _jsxs15(ModalActions2, {
          children: [/* @__PURE__ */ _jsx18(Button10, {
            variant: "tertiary",
            size: "large",
            onClick: onClose,
            disabled: isLoading,
            children: /* @__PURE__ */ _jsx18(Translation, {
              id: "actions.cancel"
            })
          }), /* @__PURE__ */ _jsx18(Button10, {
            type: "submit",
            isLoading,
            size: "large",
            children: /* @__PURE__ */ _jsx18(Translation, {
              strings: ["Send", "Enviar"]
            })
          })]
        })
      })]
    })
  });
};
var Title3 = ({
  children
}) => /* @__PURE__ */ _jsx18(Spacer11, {
  marginBottom: "12px",
  children: /* @__PURE__ */ _jsx18(Line6, {
    size: font9.small,
    weight: font9.weight.medium,
    children
  })
});

// src/components/management/link-auth/LinkEmailPassword.tsx
import { jsx as _jsx19, jsxs as _jsxs16, Fragment as _Fragment6 } from "react/jsx-runtime";
var LinkEmailPassword = () => {
  const {
    user
  } = useFirebase();
  const [isModalOpen, openModal, closeModal] = useToggle2(false);
  if (!user || getIsPasswordLogin(user))
    return null;
  return /* @__PURE__ */ _jsxs16(_Fragment6, {
    children: [/* @__PURE__ */ _jsx19(Container6, {
      radius: radius4.large,
      border: `1px solid ${colors8.line.neutralSoft}`,
      padding: "12px 18px",
      tabletPadding: "24px 36px",
      children: /* @__PURE__ */ _jsxs16(Flexer15, {
        column: true,
        tabletRow: true,
        gap: "9px",
        tabletGap: "24px",
        tabletAlignCenter: true,
        spaceBetween: true,
        children: [/* @__PURE__ */ _jsxs16(Flexer15, {
          column: true,
          gap: "6px",
          tabletGap: "12px",
          children: [/* @__PURE__ */ _jsxs16(Heading7, {
            children: ["\u{1F517}\xA0 ", /* @__PURE__ */ _jsx19(Translation, {
              strings: ["Change email", "Cambiar email"]
            })]
          }), /* @__PURE__ */ _jsx19(Paragraph6, {
            children: /* @__PURE__ */ _jsx19(Translation, {
              strings: [`You can change your email, in which case you'll need to add a password. Alternatively, you can add a password for your current email if you wish to keep it. Once changed, you'll be able to log in using Google, as you have been doing until now, or with the new credentials provided.`, "Puedes cambiar tu email, para lo que tendr\xE1s que a\xF1adir una contrase\xF1a. O puedes a\xF1adir una contrase\xF1a a tu email actual si quieres mantener el mismo. Una vez cambiado podr\xE1s iniciar sesi\xF3n a trav\xE9s de Google, como hasta ahora, o con los cambios que hayas definido."]
            })
          })]
        }), /* @__PURE__ */ _jsx19(Spacer12, {
          children: /* @__PURE__ */ _jsx19(ChipButton2, {
            variant: "highlight",
            onClick: openModal,
            children: /* @__PURE__ */ _jsx19(Translation, {
              strings: ["Change", "Cambiar"]
            })
          })
        })]
      })
    }), isModalOpen && /* @__PURE__ */ _jsx19(LinkEmailPasswordModal, {
      onClose: closeModal
    })]
  });
};

// src/components/management/MfaManagement.tsx
import { useRouteMatch, Route, Switch } from "react-router-dom";

// src/hooks/use-is-mfa-sms-enrollment-enabled.ts
var useIsMfaSmsEnrollmentEnabled = () => {
  const {
    isMfaSmsEnrollmentEnabled
  } = useConfig();
  return {
    mfaSmsEnrollmentEnabled: isMfaSmsEnrollmentEnabled
  };
};

// src/components/management/MfaEnrollPhoneModal.tsx
import { useState as useState19 } from "react";
import { useHistory as useHistory6 } from "react-router-dom";
import styled4 from "styled-components";
import { colors as colors9, font as font10, Button as Button12, Flexer as Flexer16, Form as Form10, InlineLink as InlineLink3, Input as Input9, Line as Line8, ModalBodyLegacy as ModalBody4, ModalHeaderLegacy as ModalHeader4, ModalLegacy as Modal7, ModalTitleLegacy as ModalTitle4, Paragraph as Paragraph7, Spacer as Spacer13 } from "@taxfix/scouts-ui";

// src/hooks/use-enroll-phone.ts
import { getAuth as getAuth11, multiFactor as multiFactor2, AuthErrorCodes as AuthErrorCodes3, PhoneAuthProvider as PhoneAuthProvider3, PhoneMultiFactorGenerator as PhoneMultiFactorGenerator5 } from "firebase/auth";
import { useState as useState17 } from "react";
import { addErrorToast, addSuccessToast as addSuccessToast2 } from "@taxfix/scouts-ui";
var useEnrollPhone = () => {
  const {
    user
  } = useFirebase();
  const translation = useTranslation();
  const [verificationId, setVerificationId] = useState17("");
  const [isLoading, setIsLoading] = useState17(false);
  const [requiresReauthentication, setRequiresReauthentication] = useState17(false);
  const translateError = useTranslationError();
  const triggerVerificationCodeSMS = ({
    phoneNumber,
    recaptchaVerifier
  }) => {
    if (!user)
      return;
    setIsLoading(true);
    return multiFactor2(user).getSession().then((multiFactorSession) => {
      const phoneInfoOptions = {
        phoneNumber,
        session: multiFactorSession
      };
      return new PhoneAuthProvider3(getAuth11()).verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
    }).then((givenVerificationId) => {
      setVerificationId(givenVerificationId);
      return {
        data: givenVerificationId
      };
    }).catch((error) => {
      if (error.code === AuthErrorCodes3.TOKEN_EXPIRED || error.code === AuthErrorCodes3.CREDENTIAL_TOO_OLD_LOGIN_AGAIN)
        setRequiresReauthentication(true);
      else
        addErrorToast({
          body: translateError(error)
        });
      return {
        error
      };
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const submitVerificationCode = ({
    verificationCode,
    phoneNumber
  }) => {
    if (!user)
      return;
    const cred = PhoneAuthProvider3.credential(verificationId, verificationCode);
    const multiFactorAssertion = PhoneMultiFactorGenerator5.assertion(cred);
    const mfaDisplayName = "Taxfix";
    setIsLoading(true);
    return multiFactor2(user).enroll(multiFactorAssertion, mfaDisplayName).then(() => {
      addSuccessToast2({
        body: translation({
          id: "result.phoneAdded"
        }, {
          phone: phoneNumber
        })
      });
      return {
        data: void 0
      };
    }).catch((error) => {
      if (error.code === AuthErrorCodes3.CREDENTIAL_TOO_OLD_LOGIN_AGAIN)
        setRequiresReauthentication(true);
      else
        addErrorToast({
          body: translateError(error)
        });
      return {
        error
      };
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    isLoading,
    isVerificationCodeSmsSent: !!verificationId,
    requiresReauthentication,
    submitVerificationCode,
    triggerVerificationCodeSMS
  };
};

// src/components/management/nested-path-context/use-get-nested-path.ts
import { useContext as useContext3 } from "react";

// src/components/management/nested-path-context/nested-path-context.ts
import { createContext as createContext3 } from "react";
var NestedPathContext = /* @__PURE__ */ createContext3(() => "");

// src/components/management/nested-path-context/use-get-nested-path.ts
var useGetNestedPath = () => {
  return useContext3(NestedPathContext);
};

// src/components/management/RequiresReauthenticationModal.tsx
import { Button as Button11, Line as Line7, ModalActionsLegacy as ModalActions3, ModalBodyLegacy as ModalBody3, ModalFooterLegacy as ModalFooter3, ModalHeaderLegacy as ModalHeader3, ModalLegacy as Modal6, ModalTitleLegacy as ModalTitle3 } from "@taxfix/scouts-ui";

// src/hooks/use-logout.ts
import { getAuth as getAuth12, signOut as signOut2 } from "firebase/auth";
import { useCallback as useCallback4, useState as useState18 } from "react";
var useLogout = () => {
  const {
    isInitialized
  } = useFirebase();
  const [isLoading, setIsLoading] = useState18(false);
  const [isSuccess, setIsSuccess] = useState18(false);
  const logout = useCallback4(() => {
    if (!isInitialized)
      return;
    const auth = getAuth12();
    if (!auth)
      return;
    setIsLoading(true);
    signOut2(auth).catch(() => {
      setIsSuccess(false);
    }).finally(() => {
      setIsLoading(false);
      setIsSuccess(true);
    });
  }, [isInitialized]);
  return {
    logout,
    isLoading,
    isSuccess
  };
};

// src/components/management/RequiresReauthenticationModal.tsx
import { jsx as _jsx20, jsxs as _jsxs17 } from "react/jsx-runtime";
var RequiresReauthenticationModal = ({
  onClose
}) => {
  const {
    logout
  } = useLogout();
  return /* @__PURE__ */ _jsxs17(Modal6, {
    onClose,
    children: [/* @__PURE__ */ _jsx20(ModalHeader3, {
      children: /* @__PURE__ */ _jsx20(ModalTitle3, {
        children: /* @__PURE__ */ _jsx20(Translation, {
          strings: ["This action requires recent authentication", "Esta operaci\xF3n es sensible y necesita autenticaci\xF3n reciente"]
        })
      })
    }), /* @__PURE__ */ _jsx20(ModalBody3, {
      children: /* @__PURE__ */ _jsx20(Line7, {
        children: /* @__PURE__ */ _jsx20(Translation, {
          strings: ["As this is a sensitive operation, we kindly ask you to log in again before we can continue", "Como esta es una operaci\xF3n sensible, tienes que iniciar sesi\xF3n nuevamente antes de poder continuar"]
        })
      })
    }), /* @__PURE__ */ _jsx20(ModalFooter3, {
      children: /* @__PURE__ */ _jsx20(ModalActions3, {
        children: /* @__PURE__ */ _jsx20(Button11, {
          onClick: logout,
          children: /* @__PURE__ */ _jsx20(Translation, {
            strings: ["Click here to log in again", "Volver a iniciar sesi\xF3n"]
          })
        })
      })
    })]
  });
};

// src/components/management/MfaEnrollPhoneModal.tsx
import { jsx as _jsx21, jsxs as _jsxs18 } from "react/jsx-runtime";
var MfaEnrollPhoneModal = () => {
  const [phoneNumber, setPhoneNumber] = useState19("");
  const [verificationCode, setVerificationCode] = useState19("");
  const history = useHistory6();
  const translation = useTranslation();
  const {
    isRecaptchaReady,
    startRecaptchaVerification,
    initRecaptcha
  } = useRecaptcha();
  const {
    isVerificationCodeSmsSent,
    isLoading,
    triggerVerificationCodeSMS,
    submitVerificationCode,
    requiresReauthentication
  } = useEnrollPhone();
  const getNestedPath = useGetNestedPath();
  const handleChangePhoneNumber = ({
    value
  }) => {
    setPhoneNumber(value);
  };
  const handleChangeVerificationCode = ({
    value
  }) => {
    const regexNonDigit = /\D/gim;
    const valueWithNumbersOnly = value.replace(regexNonDigit, "");
    setVerificationCode(valueWithNumbersOnly);
  };
  const handleSubmitPhoneNumber = () => {
    startRecaptchaVerification()?.then((recaptchaVerifier) => {
      if (!recaptchaVerifier)
        return;
      triggerVerificationCodeSMS({
        phoneNumber,
        recaptchaVerifier
      });
    });
  };
  const handleSubmitVerificationCode = () => {
    submitVerificationCode({
      verificationCode,
      phoneNumber
    })?.then((result) => {
      if (result.error)
        return;
      history.push(getNestedPath());
    });
  };
  const handleClose = () => {
    history.push(getNestedPath());
  };
  if (requiresReauthentication)
    return /* @__PURE__ */ _jsx21(RequiresReauthenticationModal, {
      onClose: handleClose
    });
  return (
    // Lower z-index to not overlap with the recaptcha challenge
    /* @__PURE__ */ _jsxs18(Modal7, {
      onClose: handleClose,
      zIndex: 1e4,
      children: [/* @__PURE__ */ _jsx21(ModalHeader4, {
        children: /* @__PURE__ */ _jsx21(ModalTitle4, {
          children: /* @__PURE__ */ _jsx21(Translation, {
            strings: ["Set up phone number for 2-step authentication", "Configura tu tel\xE9fono para autenticarte"]
          })
        })
      }), /* @__PURE__ */ _jsx21(ModalBody4, {
        children: /* @__PURE__ */ _jsxs18(Flexer16, {
          column: true,
          gap: "24px",
          children: [!isVerificationCodeSmsSent && /* @__PURE__ */ _jsx21(Form10, {
            onSubmit: handleSubmitPhoneNumber,
            children: /* @__PURE__ */ _jsxs18(Flexer16, {
              column: true,
              gap: "12px",
              tabletGap: "18px",
              children: [/* @__PURE__ */ _jsx21(Input9, {
                type: "tel",
                name: "phoneNumber",
                value: phoneNumber || "",
                onChange: handleChangePhoneNumber,
                isLarge: true,
                inputMode: "numeric",
                placeholder: translation({
                  id: "labels.phoneNumberPlaceholder"
                }),
                maxLength: 20,
                required: true,
                floatingLabel: translation({
                  id: "labels.phoneNumber"
                }),
                shouldAlwaysDisplayFloatingLabel: true
              }), /* @__PURE__ */ _jsx21(Spacer13, {
                children: /* @__PURE__ */ _jsx21(Button12, {
                  type: "submit",
                  isFullWidth: true,
                  isLoading,
                  disabled: !isRecaptchaReady,
                  size: "large",
                  children: /* @__PURE__ */ _jsx21(Translation, {
                    id: "actions.continue"
                  })
                })
              })]
            })
          }), isVerificationCodeSmsSent && /* @__PURE__ */ _jsxs18(Flexer16, {
            column: true,
            gap: "12px",
            tabletGap: "24px",
            children: [/* @__PURE__ */ _jsx21(Line8, {
              children: /* @__PURE__ */ _jsx21(Translation, {
                id: "description.smsSentTo",
                values: {
                  phone: phoneNumber || "_"
                }
              })
            }), /* @__PURE__ */ _jsx21(Form10, {
              onSubmit: handleSubmitVerificationCode,
              children: /* @__PURE__ */ _jsxs18(Flexer16, {
                column: true,
                gap: "12px",
                tabletGap: "18px",
                children: [/* @__PURE__ */ _jsx21(Input9, {
                  type: "text",
                  inputMode: "numeric",
                  minLength: 6,
                  name: "verificationCode",
                  value: verificationCode,
                  isLarge: true,
                  onChange: handleChangeVerificationCode,
                  autoComplete: "one-time-code",
                  autoFocus: true,
                  required: true,
                  floatingLabel: translation({
                    id: "labels.verificationCode"
                  }),
                  shouldAlwaysDisplayFloatingLabel: true
                }), /* @__PURE__ */ _jsx21(Spacer13, {
                  children: /* @__PURE__ */ _jsx21(Button12, {
                    type: "submit",
                    isLoading,
                    size: "large",
                    isFullWidth: true,
                    children: /* @__PURE__ */ _jsx21(Translation, {
                      id: "actions.verify"
                    })
                  })
                })]
              })
            })]
          }), /* @__PURE__ */ _jsxs18(Spacer13, {
            children: [/* @__PURE__ */ _jsx21(Paragraph7, {
              size: font10.tiny,
              color: colors9.text.neutral,
              alignCenter: true,
              children: /* @__PURE__ */ _jsx21(Translation, {
                id: "legal.recaptcha",
                values: {
                  privacyLink: (chunks) => /* @__PURE__ */ _jsx21(InlineLink3, {
                    href: "https://policies.google.com/privacy",
                    color: colors9.text.neutral,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: chunks
                  }),
                  termsLink: (chunks) => /* @__PURE__ */ _jsx21(InlineLink3, {
                    href: "https://policies.google.com/terms",
                    color: colors9.text.neutral,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: chunks
                  })
                }
              })
            }), /* @__PURE__ */ _jsx21(RecaptchaContainer2, {
              ref: (element) => element && initRecaptcha(element)
            })]
          })]
        })
      })]
    })
  );
};
var RecaptchaContainer2 = styled4.div.withConfig({
  displayName: "MfaEnrollPhoneModal__RecaptchaContainer",
  componentId: "sc-1oekpl7-0"
})(["overflow:hidden;height:1px;.grecaptcha-badge{position:relative !important;visibility:hidden;}"]);

// src/components/management/MfaEnrollTotpModal.tsx
import { AuthErrorCodes as AuthErrorCodes4 } from "firebase/auth";
import { QRCodeSVG } from "qrcode.react";
import { useEffect as useEffect5, useState as useState22 } from "react";
import { useHistory as useHistory7, Redirect } from "react-router-dom";
import { addErrorToast as addErrorToast2, colors as colors10, font as font11, radius as radius5, shadows, Button as Button13, Container as Container7, Flexer as Flexer17, Input as Input10, Line as Line9, ModalActionsLegacy as ModalActions4, ModalBodyLegacy as ModalBody5, ModalFooterLegacy as ModalFooter4, ModalHeaderLegacy as ModalHeader5, ModalLegacy as Modal8, ModalTitleLegacy as ModalTitle5, Spacer as Spacer14 } from "@taxfix/scouts-ui";

// src/hooks/use-enroll-totp.ts
import { multiFactor as multiFactor3, TotpMultiFactorGenerator as TotpMultiFactorGenerator4 } from "firebase/auth";
import { useState as useState20 } from "react";
var useEnrollTotp = () => {
  const {
    totpLabel
  } = useConfig();
  const {
    user
  } = useFirebase();
  const [isLoading, setIsLoading] = useState20(false);
  const [error, setError] = useState20(null);
  const enrollTotp = ({
    totpSecret,
    verificationCode
  }) => {
    if (!user)
      return;
    setIsLoading(true);
    const multiFactorAssertion = TotpMultiFactorGenerator4.assertionForEnrollment(totpSecret, verificationCode);
    return multiFactor3(user).enroll(multiFactorAssertion, `${totpLabel}${user.email}`).then(() => ({
      data: void 0
    })).catch((error2) => {
      setError(error2);
      return {
        error: error2
      };
    }).finally(() => setIsLoading(false));
  };
  return {
    enrollTotp,
    isLoading,
    error
  };
};

// src/hooks/use-totp-enrollment-secret.ts
import { multiFactor as multiFactor4, TotpMultiFactorGenerator as TotpMultiFactorGenerator5 } from "firebase/auth";
import { useEffect as useEffect4, useState as useState21 } from "react";
var useTotpEnrollmentSecret = () => {
  const {
    user
  } = useFirebase();
  const [totpSecret, setTotpSecret] = useState21(null);
  const [error, setError] = useState21(null);
  const [isLoading, setIsLoading] = useState21(false);
  useEffect4(() => {
    const generateEnrollmentSecret = async () => {
      if (!user)
        return;
      setIsLoading(true);
      try {
        const multiFactorSession = await multiFactor4(user).getSession();
        const generatedTotpSecret = await TotpMultiFactorGenerator5.generateSecret(multiFactorSession);
        setTotpSecret(generatedTotpSecret);
      } catch (error2) {
        setError(error2);
      } finally {
        setIsLoading(false);
      }
    };
    generateEnrollmentSecret();
  }, [user]);
  return {
    totpSecret,
    isLoading,
    error
  };
};

// src/components/management/MfaEnrollTotpModal.tsx
import { jsx as _jsx22, jsxs as _jsxs19 } from "react/jsx-runtime";
var MfaEnrollTotpModal = () => {
  const {
    totpLabel
  } = useConfig();
  const {
    user
  } = useFirebase();
  const history = useHistory7();
  const getNestedPath = useGetNestedPath();
  const [verificationCode, setVerificationCode] = useState22("");
  const {
    totpSecret,
    isLoading: isSecretLoading,
    error: totpSecretError
  } = useTotpEnrollmentSecret();
  const {
    enrollTotp,
    isLoading: isEnrollLoading
  } = useEnrollTotp();
  const errorMessage = useTranslateError(totpSecretError);
  const translateError = useTranslationError();
  const translation = useTranslation();
  const requiresReauthentication = totpSecretError?.code === AuthErrorCodes4.CREDENTIAL_TOO_OLD_LOGIN_AGAIN;
  useEffect5(() => {
    if (!errorMessage || requiresReauthentication)
      return;
    addErrorToast2({
      body: errorMessage
    });
  }, [errorMessage, requiresReauthentication]);
  const handleEnroll = (submittedCode) => {
    if (!totpSecret)
      return;
    enrollTotp({
      totpSecret,
      verificationCode: submittedCode.trim()
    })?.then((result) => {
      if (result.error) {
        addErrorToast2({
          body: translateError(result.error)
        });
        return;
      }
      history.push(getNestedPath());
    });
  };
  const handleClose = () => {
    history.push(getNestedPath());
  };
  if (requiresReauthentication)
    return /* @__PURE__ */ _jsx22(RequiresReauthenticationModal, {
      onClose: handleClose
    });
  if (errorMessage)
    return /* @__PURE__ */ _jsx22(Redirect, {
      to: getNestedPath()
    });
  return /* @__PURE__ */ _jsxs19(Modal8, {
    onClose: handleClose,
    isLoading: isSecretLoading,
    children: [/* @__PURE__ */ _jsx22(ModalHeader5, {
      children: /* @__PURE__ */ _jsx22(ModalTitle5, {
        children: /* @__PURE__ */ _jsx22(Translation, {
          strings: ["Set up authenticator app", "Configura tu aplicaci\xF3n de autenticaci\xF3n"]
        })
      })
    }), /* @__PURE__ */ _jsx22(ModalBody5, {
      children: /* @__PURE__ */ _jsxs19(Flexer17, {
        column: true,
        gap: "12px",
        tabletGap: "24px",
        children: [/* @__PURE__ */ _jsx22(Line9, {
          children: /* @__PURE__ */ _jsx22(Translation, {
            strings: ["Please scan the QR code with your authenticator app", "Escanea el siguiente c\xF3digo QR con tu aplicaci\xF3n de autenticaci\xF3n"]
          })
        }), totpSecret && /* @__PURE__ */ _jsx22(Flexer17, {
          justifyCenter: true,
          children: /* @__PURE__ */ _jsx22(Container7, {
            radius: radius5.large,
            shadow: shadows.high,
            border: `1px solid ${colors10.line.neutralSoft}`,
            padding: "12px",
            children: /* @__PURE__ */ _jsx22(QRCodeSVG, {
              value: totpSecret.generateQrCodeUrl(user?.email || "", totpLabel)
            })
          })
        }), /* @__PURE__ */ _jsx22(Spacer14, {
          children: /* @__PURE__ */ _jsxs19(Line9, {
            color: colors10.text.neutral,
            textAlign: "center",
            size: font11.smaller,
            children: [/* @__PURE__ */ _jsx22(Translation, {
              strings: ["Alternatively, type the following code into your authenticator app:", "Tambi\xE9n puedes introducir el siguiente c\xF3digo en tu aplicaci\xF3n de autenticaci\xF3n:"]
            }), " ", /* @__PURE__ */ _jsx22("strong", {
              style: {
                wordWrap: "break-word"
              },
              children: totpSecret?.secretKey
            })]
          })
        }), /* @__PURE__ */ _jsx22(Line9, {
          children: /* @__PURE__ */ _jsx22(Translation, {
            strings: ["Once added, enter the code you see in the app", "Una vez que lo hayas a\xF1adido a tu aplicaci\xF3n de autenticaci\xF3n, introduce el c\xF3digo que ver\xE1s en la aplicaci\xF3n a continuaci\xF3n"]
          })
        }), /* @__PURE__ */ _jsx22(Input10, {
          inputMode: "numeric",
          name: "verificationCode",
          value: verificationCode,
          floatingLabel: translation({
            id: "labels.verificationCode"
          }),
          onChange: ({
            value
          }) => setVerificationCode(value),
          autoComplete: "one-time-code",
          shouldAlwaysDisplayFloatingLabel: true,
          isLarge: true
        })]
      })
    }), /* @__PURE__ */ _jsx22(ModalFooter4, {
      children: /* @__PURE__ */ _jsx22(ModalActions4, {
        children: /* @__PURE__ */ _jsx22(Button13, {
          isLoading: isEnrollLoading,
          onClick: () => handleEnroll(verificationCode),
          size: "large",
          children: /* @__PURE__ */ _jsx22(Translation, {
            id: "actions.verify"
          })
        })
      })
    })]
  });
};

// src/components/management/MfaStatus.tsx
import { colors as colors14, radius as radius9, Container as Container11, Flexer as Flexer21, Heading as Heading10, Paragraph as Paragraph8, Spacer as Spacer18 } from "@taxfix/scouts-ui";

// src/components/management/MfaStatusPhone.tsx
import { useState as useState24 } from "react";
import { useHistory as useHistory8 } from "react-router-dom";
import { addErrorToast as addErrorToast3, addSuccessToast as addSuccessToast3, colors as colors11, font as font12, radius as radius6, Button as Button14, ButtonLink as ButtonLink3, ConfirmationModal, Container as Container8, Flexer as Flexer18, Heading as Heading8, Line as Line10, List, Spacer as Spacer15 } from "@taxfix/scouts-ui";

// src/helpers/mfa-management/get-phone-factors.ts
import { multiFactor as multiFactor5, PhoneMultiFactorGenerator as PhoneMultiFactorGenerator6 } from "firebase/auth";
var getPhoneFactors = (user) => {
  return multiFactor5(user).enrolledFactors.filter((factorInfo) => factorInfo.factorId === PhoneMultiFactorGenerator6.FACTOR_ID);
};

// src/hooks/use-unenroll-mfa.ts
import { multiFactor as multiFactor6 } from "firebase/auth";
import { useState as useState23 } from "react";
var useUnenrollMfa = () => {
  const {
    user
  } = useFirebase();
  const [isLoading, setIsLoading] = useState23(false);
  const [requiresReauthentication, setRequiresReauthentication] = useState23(false);
  const unenroll = (factorToRemove) => {
    if (!user)
      return;
    const multifactorUser = multiFactor6(user);
    setIsLoading(true);
    return multifactorUser.unenroll(factorToRemove).then(() => ({
      data: void 0
    })).catch((error) => {
      setRequiresReauthentication(true);
      return {
        error
      };
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    isLoading,
    requiresReauthentication,
    unenrollMfa: unenroll
  };
};

// src/components/management/MfaStatusPhone.tsx
import { jsx as _jsx23, jsxs as _jsxs20, Fragment as _Fragment7 } from "react/jsx-runtime";
var MfaStatusPhone = () => {
  const {
    user
  } = useFirebase();
  const history = useHistory8();
  const getNestedPath = useGetNestedPath();
  const [factorToDelete, setFactorToDelete] = useState24(null);
  const {
    unenrollMfa,
    isLoading,
    requiresReauthentication
  } = useUnenrollMfa();
  const translation = useTranslation();
  const translateError = useTranslationError();
  const {
    mfaSmsEnrollmentEnabled
  } = useIsMfaSmsEnrollmentEnabled();
  if (!user)
    return null;
  const handleUnenroll = (factor) => {
    unenrollMfa(factor)?.then((result) => {
      if (result.error) {
        addErrorToast3({
          body: translateError(result.error)
        });
        return;
      }
      addSuccessToast3({
        body: translation({
          id: "result.deletedPhone"
        }, {
          phone: factor.phoneNumber
        })
      });
      setFactorToDelete(null);
    });
  };
  const hasEnrolledPhone = getHasEnrolledPhone(user);
  const phoneFactors = getPhoneFactors(user);
  const shouldDisplayRemove = getHasEnrolledMultipleMfa(user);
  if (!hasEnrolledPhone && !mfaSmsEnrollmentEnabled)
    return null;
  return /* @__PURE__ */ _jsxs20(_Fragment7, {
    children: [requiresReauthentication && /* @__PURE__ */ _jsx23(RequiresReauthenticationModal, {
      onClose: () => window.location.reload()
    }), /* @__PURE__ */ _jsxs20(Container8, {
      radius: radius6.large,
      padding: "12px 18px",
      tabletPadding: "24px 36px",
      background: hasEnrolledPhone ? colors11.surface.affirm : colors11.surface.neutral,
      children: [!hasEnrolledPhone && /* @__PURE__ */ _jsxs20(Flexer18, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [/* @__PURE__ */ _jsxs20(Flexer18, {
          column: true,
          gap: "6px",
          tabletGap: "12px",
          children: [/* @__PURE__ */ _jsx23(Heading8, {
            size: font12.normal,
            children: /* @__PURE__ */ _jsx23(Translation, {
              strings: ["Set up phone number", "Configura tu tel\xE9fono"]
            })
          }), /* @__PURE__ */ _jsx23(Line10, {
            children: /* @__PURE__ */ _jsx23(Translation, {
              strings: ["Add a phone number to receive SMS codes for logging in", "Durante el inicio de sesi\xF3n, recibir\xE1s un SMS con un c\xF3digo de verificaci\xF3n"]
            })
          })]
        }), /* @__PURE__ */ _jsx23(Spacer15, {
          children: /* @__PURE__ */ _jsx23(Button14, {
            variant: "secondary",
            onClick: () => history.push(getNestedPath(PATH_MFA_ENROLL_PHONE)),
            children: /* @__PURE__ */ _jsx23(Translation, {
              strings: ["Add phone number", "A\xF1adir tu tel\xE9fono"]
            })
          })
        })]
      }), hasEnrolledPhone && /* @__PURE__ */ _jsxs20(Flexer18, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [/* @__PURE__ */ _jsx23(Heading8, {
          size: font12.normal,
          children: /* @__PURE__ */ _jsx23(Translation, {
            strings: ["Active phone numbers", "Has a\xF1adido uno o varios n\xFAmeros de tel\xE9fono"]
          })
        }), /* @__PURE__ */ _jsx23(List, {
          itemsBackground: colors11.surface.base,
          children: phoneFactors.map((phoneFactor) => /* @__PURE__ */ _jsx23(List.Item, {
            children: /* @__PURE__ */ _jsxs20(Flexer18, {
              column: true,
              tabletRow: true,
              gap: "3px",
              tabletGap: "9px",
              tabletAlignCenter: true,
              children: [/* @__PURE__ */ _jsx23(Spacer15, {
                children: phoneFactor.phoneNumber
              }), shouldDisplayRemove && /* @__PURE__ */ _jsx23(Spacer15, {
                children: /* @__PURE__ */ _jsx23(Button14, {
                  size: "small",
                  variant: "tertiary",
                  color: "error",
                  onClick: () => setFactorToDelete(phoneFactor),
                  children: /* @__PURE__ */ _jsx23(Translation, {
                    id: "actions.remove"
                  })
                })
              })]
            })
          }, phoneFactor.phoneNumber))
        }), mfaSmsEnrollmentEnabled && /* @__PURE__ */ _jsx23(Spacer15, {
          children: /* @__PURE__ */ _jsx23(ButtonLink3, {
            onClick: () => history.push(getNestedPath(PATH_MFA_ENROLL_PHONE)),
            children: /* @__PURE__ */ _jsx23(Translation, {
              strings: ["Add phone number", "A\xF1adir otro tel\xE9fono"]
            })
          })
        })]
      })]
    }), !!factorToDelete && /* @__PURE__ */ _jsx23(ConfirmationModal, {
      onConfirm: () => handleUnenroll(factorToDelete),
      onCancel: () => setFactorToDelete(null),
      isLoading,
      labelCancel: translation({
        id: "actions.cancel"
      }),
      labelConfirm: translation({
        id: "actions.remove"
      }),
      title: translation({
        id: "labels.confirmPhoneRemove"
      }, {
        phone: factorToDelete.phoneNumber
      })
    })]
  });
};

// src/components/management/MfaStatusTotp.tsx
import { useHistory as useHistory9 } from "react-router-dom";
import { useToggle as useToggle3 } from "@taxfix/scouts-helpers";
import { addErrorToast as addErrorToast4, addSuccessToast as addSuccessToast4, colors as colors12, font as font13, radius as radius7, Button as Button15, ConfirmationModal as ConfirmationModal2, Container as Container9, Flexer as Flexer19, Heading as Heading9, Line as Line11, Spacer as Spacer16 } from "@taxfix/scouts-ui";

// src/helpers/mfa-management/get-totp-factor.ts
import { multiFactor as multiFactor7, TotpMultiFactorGenerator as TotpMultiFactorGenerator6 } from "firebase/auth";
var getTotpFactor = (user) => {
  return multiFactor7(user).enrolledFactors.find((factor) => factor.factorId === TotpMultiFactorGenerator6.FACTOR_ID);
};

// src/components/management/MfaStatusTotp.tsx
import { jsx as _jsx24, jsxs as _jsxs21, Fragment as _Fragment8 } from "react/jsx-runtime";
var MfaStatusTotp = () => {
  const {
    user
  } = useFirebase();
  const translation = useTranslation();
  const translateError = useTranslationError();
  const getNestedPath = useGetNestedPath();
  const [isRemoveConfirmationModalOpen, openRemoveConfirmationModal, closeRemoveConfirmationModal] = useToggle3();
  const {
    unenrollMfa,
    isLoading: isUnenrollTotpLoading,
    requiresReauthentication
  } = useUnenrollMfa();
  const history = useHistory9();
  if (!user)
    return null;
  const handleConfirmRemove = () => {
    const factorToRemove = getTotpFactor(user);
    if (!factorToRemove)
      return;
    unenrollMfa(factorToRemove)?.then((result) => {
      if (result.error) {
        addErrorToast4({
          body: translateError(result.error)
        });
        return;
      }
      addSuccessToast4({
        body: translation({
          id: "result.deletedTotp"
        })
      });
      closeRemoveConfirmationModal();
    });
  };
  const hasEnrolledTotp = getHasEnrolledTotp(user);
  const shouldDisplayRemove = getHasEnrolledMultipleMfa(user);
  return /* @__PURE__ */ _jsxs21(_Fragment8, {
    children: [requiresReauthentication && /* @__PURE__ */ _jsx24(RequiresReauthenticationModal, {
      onClose: () => window.location.reload()
    }), /* @__PURE__ */ _jsxs21(Container9, {
      radius: radius7.large,
      padding: "12px 18px",
      tabletPadding: "24px 36px",
      background: hasEnrolledTotp ? colors12.surface.affirm : colors12.surface.highlight,
      children: [!hasEnrolledTotp && /* @__PURE__ */ _jsxs21(Flexer19, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [/* @__PURE__ */ _jsxs21(Flexer19, {
          column: true,
          gap: "6px",
          tabletGap: "12px",
          children: [/* @__PURE__ */ _jsx24(Heading9, {
            size: font13.normal,
            children: /* @__PURE__ */ _jsx24(Translation, {
              strings: ["Use an authenticator app (recommended)", "Configura tu aplicaci\xF3n de autenticaci\xF3n (recomendado)"]
            })
          }), /* @__PURE__ */ _jsx24(Line11, {
            children: /* @__PURE__ */ _jsx24(Translation, {
              strings: ["Apps like Google Authenticator, Microsoft Authenticator or Authy are recommended and available on the Apple App Store or Google Play Store.", "Las aplicaciones de autenticaci\xF3n generan autom\xE1ticamente nuevos c\xF3digos cada 30 segundos. Se pueden descargar desde Apple App Store / Google Play Store. Recomendamos utilizar Google Authenticator, Microsoft Authenticator o Authy."]
            })
          })]
        }), /* @__PURE__ */ _jsx24(Spacer16, {
          children: /* @__PURE__ */ _jsx24(Button15, {
            onClick: () => history.push(getNestedPath(PATH_MFA_ENROLL_TOTP)),
            children: /* @__PURE__ */ _jsx24(Translation, {
              strings: ["Set up authenticator app", "Configura tu aplicaci\xF3n de autenticaci\xF3n"]
            })
          })
        })]
      }), hasEnrolledTotp && /* @__PURE__ */ _jsxs21(Flexer19, {
        column: true,
        gap: "12px",
        tabletGap: "18px",
        children: [/* @__PURE__ */ _jsx24(Heading9, {
          size: font13.normal,
          children: /* @__PURE__ */ _jsx24(Translation, {
            strings: ["You have set up an authenticator app", "Has configurado una aplicaci\xF3n de autenticaci\xF3n"]
          })
        }), shouldDisplayRemove && /* @__PURE__ */ _jsx24(Spacer16, {
          children: /* @__PURE__ */ _jsx24(Button15, {
            size: "small",
            variant: "secondary",
            color: "error",
            onClick: openRemoveConfirmationModal,
            children: /* @__PURE__ */ _jsx24(Translation, {
              id: "actions.remove"
            })
          })
        }), isRemoveConfirmationModalOpen && /* @__PURE__ */ _jsx24(ConfirmationModal2, {
          onCancel: closeRemoveConfirmationModal,
          onConfirm: handleConfirmRemove,
          isLoading: isUnenrollTotpLoading,
          labelConfirm: translation({
            id: "actions.remove"
          }),
          labelCancel: translation({
            id: "actions.cancel"
          }),
          title: translation(["Are you sure you want to remove your authenticator app?", "\xBFSeguro que quieres eliminar tu aplicaci\xF3n de autenticaci\xF3n?"])
        })]
      })]
    })]
  });
};

// src/components/management/MfaStatusUnverifiedEmail.tsx
import { useState as useState25 } from "react";
import { addErrorToast as addErrorToast5, colors as colors13, radius as radius8, Button as Button16, Container as Container10, Flexer as Flexer20, Line as Line12, Spacer as Spacer17 } from "@taxfix/scouts-ui";

// src/helpers/mfa-management/send-verification-email.ts
import { sendEmailVerification } from "firebase/auth";
var sendVerificationEmail = (user) => {
  return sendEmailVerification(user);
};

// src/components/management/MfaStatusUnverifiedEmail.tsx
import { jsx as _jsx25, jsxs as _jsxs22 } from "react/jsx-runtime";
var MfaStatusUnverifiedEmail = () => {
  const {
    user
  } = useFirebase();
  const [hasSentEmail, setHasSentEmail] = useState25(false);
  const [isLoading, setIsLoading] = useState25(false);
  const translateError = useTranslationError();
  if (!user)
    return null;
  const sendEmail = () => {
    setIsLoading(true);
    sendVerificationEmail(user).then(() => {
      setHasSentEmail(true);
    }).catch((error) => {
      addErrorToast5({
        body: translateError(error)
      });
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const reload = () => {
    window.location.reload();
  };
  return /* @__PURE__ */ _jsxs22(Container10, {
    radius: radius8.medium,
    background: colors13.surface.attention,
    padding: "12px 18px 15px",
    tabletPadding: "18px 36px",
    children: [!hasSentEmail && /* @__PURE__ */ _jsxs22(Flexer20, {
      column: true,
      tabletRow: true,
      gap: "9px",
      tabletGap: "24px",
      tabletAlignCenter: true,
      spaceBetween: true,
      children: [/* @__PURE__ */ _jsx25(Line12, {
        children: /* @__PURE__ */ _jsx25(Translation, {
          strings: ["Start by verifying your email address", "Necesitamos verificar tu email para poder activar la autenticaci\xF3n en dos pasos"]
        })
      }), /* @__PURE__ */ _jsx25(Spacer17, {
        flex: "0 1 auto",
        children: /* @__PURE__ */ _jsx25(Button16, {
          onClick: sendEmail,
          isLoading,
          children: /* @__PURE__ */ _jsx25(Translation, {
            strings: ["Send verification email", "Enviar email de verificaci\xF3n"]
          })
        })
      })]
    }), hasSentEmail && /* @__PURE__ */ _jsxs22(Flexer20, {
      column: true,
      tabletRow: true,
      gap: "9px",
      tabletGap: "24px",
      tabletAlignCenter: true,
      spaceBetween: true,
      children: [/* @__PURE__ */ _jsx25(Line12, {
        children: /* @__PURE__ */ _jsx25(Translation, {
          strings: ["We have sent you an email with a verification link, check your inbox and click on the link. Once done, reload this page.", "Te hemos enviado un email con un link de verificaci\xF3n, comprueba tu bandeja. Cuando lo hayas verificado, refresca la p\xE1gina."]
        })
      }), /* @__PURE__ */ _jsx25(Spacer17, {
        flex: "0 1 auto",
        children: /* @__PURE__ */ _jsx25(Button16, {
          onClick: reload,
          children: /* @__PURE__ */ _jsx25(Translation, {
            strings: ["Reload", "Refrescar"]
          })
        })
      })]
    })]
  });
};

// src/components/management/MfaStatus.tsx
import { jsx as _jsx26, jsxs as _jsxs23 } from "react/jsx-runtime";
var MfaStatus = () => {
  const {
    user
  } = useFirebase();
  if (!user)
    return null;
  return /* @__PURE__ */ _jsx26(Container11, {
    radius: radius9.large,
    border: `1px solid ${colors14.line.neutralSoft}`,
    padding: "12px 18px",
    tabletPadding: "24px 36px",
    children: /* @__PURE__ */ _jsxs23(Flexer21, {
      column: true,
      gap: "12px",
      tabletGap: "24px",
      children: [/* @__PURE__ */ _jsxs23(Flexer21, {
        column: true,
        gap: "6px",
        tabletGap: "12px",
        children: [/* @__PURE__ */ _jsxs23(Heading10, {
          children: ["\u{1F510}\xA0 ", /* @__PURE__ */ _jsx26(Translation, {
            strings: ["2-step authentication", "Autenticaci\xF3n en 2 pasos"]
          })]
        }), /* @__PURE__ */ _jsx26(Spacer18, {
          children: /* @__PURE__ */ _jsx26(Paragraph8, {
            children: /* @__PURE__ */ _jsx26(Translation, {
              strings: ["Boost your account's security. Alongside your password, you\u2019ll verify your identity using a one-time code from SMS or an authenticator app each time you log in.", "Configura la autenticaci\xF3n en dos pasos para a\xF1adir un nivel adicional de seguridad a tu cuenta. Inicia sesi\xF3n con tu contrase\xF1a como de costumbre y, a continuaci\xF3n, se te pedir\xE1 que introduzcas otro c\xF3digo. Configura uno o los dos m\xE9todos siguientes para obtener el c\xF3digo."]
            })
          })
        })]
      }), /* @__PURE__ */ _jsx26(Spacer18, {
        children: !user.emailVerified ? /* @__PURE__ */ _jsx26(MfaStatusUnverifiedEmail, {}) : /* @__PURE__ */ _jsxs23(Flexer21, {
          column: true,
          gap: "12px",
          tabletGap: "24px",
          children: [/* @__PURE__ */ _jsx26(MfaStatusTotp, {}), /* @__PURE__ */ _jsx26(MfaStatusPhone, {})]
        })
      })]
    })
  });
};

// src/components/management/MfaManagement.tsx
import { jsx as _jsx27, jsxs as _jsxs24 } from "react/jsx-runtime";
var MfaManagement = () => {
  const {
    url: rootUrl
  } = useRouteMatch();
  const {
    mfaSmsEnrollmentEnabled
  } = useIsMfaSmsEnrollmentEnabled();
  const getNestedPath = (path) => `${rootUrl}${path || ""}`;
  return /* @__PURE__ */ _jsxs24(NestedPathContext.Provider, {
    value: getNestedPath,
    children: [/* @__PURE__ */ _jsxs24(Switch, {
      children: [/* @__PURE__ */ _jsx27(Route, {
        path: getNestedPath(PATH_MFA_ENROLL_TOTP),
        children: /* @__PURE__ */ _jsx27(MfaEnrollTotpModal, {})
      }), mfaSmsEnrollmentEnabled && /* @__PURE__ */ _jsx27(Route, {
        path: getNestedPath(PATH_MFA_ENROLL_PHONE),
        children: /* @__PURE__ */ _jsx27(MfaEnrollPhoneModal, {})
      })]
    }), /* @__PURE__ */ _jsx27(MfaStatus, {})]
  });
};

// src/components/management/AuthManagement.tsx
import { jsx as _jsx28, jsxs as _jsxs25 } from "react/jsx-runtime";
var AuthManagement = () => {
  return /* @__PURE__ */ _jsxs25(Flexer22, {
    column: true,
    gap: "24px",
    tabletGap: "36px",
    children: [/* @__PURE__ */ _jsx28(MfaManagement, {}), /* @__PURE__ */ _jsx28(ChangePassword, {}), /* @__PURE__ */ _jsx28(LinkEmailPassword, {})]
  });
};

// src/components/management/MfaEnforcer.tsx
import { Redirect as Redirect2, Route as Route2, Switch as Switch2 } from "react-router-dom";
import { jsx as _jsx29, jsxs as _jsxs26, Fragment as _Fragment9 } from "react/jsx-runtime";
var MfaEnforcer = ({
  children
}) => {
  const {
    user
  } = useFirebase();
  if (user && !getHasEnrolledMfa(user))
    return /* @__PURE__ */ _jsxs26(Switch2, {
      children: [/* @__PURE__ */ _jsx29(Route2, {
        path: PATH_MFA_ENFORCER,
        children: /* @__PURE__ */ _jsx29(MfaManagement, {})
      }), /* @__PURE__ */ _jsx29(Redirect2, {
        to: PATH_MFA_ENFORCER
      })]
    });
  return /* @__PURE__ */ _jsx29(_Fragment9, {
    children
  });
};

// src/components/SetPasswordForm.tsx
import { getAuth as getAuth14, verifyPasswordResetCode } from "firebase/auth";
import { useEffect as useEffect6, useState as useState27 } from "react";
import { useHistory as useHistory10 } from "react-router-dom";
import { addErrorToast as addErrorToast6, colors as colors15, radius as radius10, useIsTablet as useIsTablet4, Button as Button17, Checkbox as Checkbox6, Container as Container12, Flexer as Flexer23, Form as Form11, Input as Input11, Line as Line13, Loadable as Loadable2, Spacer as Spacer19 } from "@taxfix/scouts-ui";

// src/hooks/use-confirm-password-reset.ts
import { confirmPasswordReset, getAuth as getAuth13 } from "firebase/auth";
import { useState as useState26 } from "react";
var useConfirmPasswordReset = () => {
  const [isLoading, setIsLoading] = useState26(false);
  const [isSuccess, setIsSuccess] = useState26(false);
  const [isError, setIsError] = useState26(false);
  const setPassword = ({
    code,
    password
  }) => {
    const auth = getAuth13();
    if (!auth) {
      throw new Error("Firebase auth is not initialized");
    }
    setIsLoading(true);
    confirmPasswordReset(auth, code, password).then(() => {
      setIsSuccess(true);
    }).catch(() => {
      setIsError(true);
      setIsSuccess(false);
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    setPassword,
    isLoading,
    isSuccess,
    isError
  };
};

// src/components/SetPasswordForm.tsx
import { jsx as _jsx30, jsxs as _jsxs27 } from "react/jsx-runtime";
var SetPasswordForm = ({
  resetPasswordPath,
  loginPath,
  shouldAgreeToTerms
}) => {
  const translation = useTranslation();
  const history = useHistory10();
  const auth = getAuth14();
  const config = useConfig();
  const isTablet = useIsTablet4();
  if (!auth) {
    throw new Error("Firebase auth is not initialized");
  }
  const [newPassword, setNewPassword] = useState27("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState27("");
  const [hasAgreedToTerms, setHasAgreedToTerms] = useState27(false);
  const [status, setStatus] = useState27("checking");
  const [code, setCode] = useState27("");
  const {
    setPassword,
    isLoading,
    isSuccess,
    isError
  } = useConfirmPasswordReset();
  const termsLinkRenderer = (chunks) => /* @__PURE__ */ _jsx30("a", {
    href: config.termsUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: chunks
  });
  const privacyLinkRenderer = (chunks) => /* @__PURE__ */ _jsx30("a", {
    href: config.privacyUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: chunks
  });
  useEffect6(() => {
    const params = new URLSearchParams(globalThis.location.search);
    const oobCode = params.get("oobCode") ?? "";
    setCode(oobCode);
    if (!oobCode) {
      setStatus("error");
      return;
    }
    verifyPasswordResetCode(auth, oobCode).then(() => {
      setStatus("ready");
    }).catch(() => setStatus("error"));
  }, [auth]);
  const onSubmit = async () => {
    if (shouldAgreeToTerms && !hasAgreedToTerms) {
      addErrorToast6({
        body: translation({
          id: "errors.hasNotAgreedToTerms"
        })
      });
      return;
    }
    if (newPassword !== newPasswordConfirm) {
      addErrorToast6({
        body: translation({
          id: "error.passwordNotMatching"
        })
      });
      return;
    }
    const passwordLeakResult = await getIsPasswordLeaked(newPassword);
    if (passwordLeakResult.data) {
      addErrorToast6({
        body: translation({
          id: "errors.weakPassword"
        })
      });
      return;
    }
    setPassword({
      code,
      password: newPassword
    });
  };
  return /* @__PURE__ */ _jsxs27(Loadable2, {
    isLoading: status === "checking",
    children: [(status === "error" || isError) && /* @__PURE__ */ _jsx30(Container12, {
      background: colors15.surface.attention,
      padding: "24px",
      radius: radius10.medium,
      role: "alert",
      children: /* @__PURE__ */ _jsxs27(Flexer23, {
        column: true,
        gap: "16px",
        alignCenter: true,
        children: [/* @__PURE__ */ _jsx30(Line13, {
          children: /* @__PURE__ */ _jsx30(Translation, {
            id: "errors.invalidSetPasswordLink"
          })
        }), /* @__PURE__ */ _jsx30(Button17, {
          onClick: () => history.push(resetPasswordPath ?? "/"),
          children: /* @__PURE__ */ _jsx30(Translation, {
            id: "actions.requestNewLink"
          })
        })]
      })
    }), status === "ready" && !isSuccess && /* @__PURE__ */ _jsx30(Form11, {
      onSubmit,
      children: /* @__PURE__ */ _jsxs27(Flexer23, {
        column: true,
        gap: "24px",
        children: [/* @__PURE__ */ _jsxs27(Flexer23, {
          column: true,
          gap: "12px",
          children: [/* @__PURE__ */ _jsx30(Input11, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.password"
            }),
            type: "password",
            name: "newPassword",
            value: newPassword,
            onChange: ({
              value
            }) => setNewPassword(value),
            placeholder: translation({
              id: "labels.password"
            }),
            "aria-label": translation({
              id: "labels.password"
            }),
            autoComplete: "none",
            required: true
          }), /* @__PURE__ */ _jsx30(Input11, {
            isLarge: true,
            floatingLabel: translation({
              id: "labels.passwordConfirm"
            }),
            type: "password",
            name: "newPasswordConfirm",
            value: newPasswordConfirm,
            onChange: ({
              value
            }) => setNewPasswordConfirm(value),
            placeholder: translation({
              id: "labels.passwordConfirm"
            }),
            autoComplete: "none",
            "aria-label": translation({
              id: "labels.passwordConfirm"
            }),
            required: true
          })]
        }), shouldAgreeToTerms && /* @__PURE__ */ _jsx30(Spacer19, {
          children: /* @__PURE__ */ _jsx30(Checkbox6, {
            checked: hasAgreedToTerms,
            label: /* @__PURE__ */ _jsx30(Translation, {
              id: "labels.agreeToTerms",
              values: {
                termsLink: termsLinkRenderer,
                privacyLink: privacyLinkRenderer
              }
            }),
            name: "hasAgreedToTerms",
            onChange: ({
              checked
            }) => setHasAgreedToTerms(checked),
            isSmall: !isTablet
          })
        }), /* @__PURE__ */ _jsx30(Spacer19, {
          children: /* @__PURE__ */ _jsx30(Button17, {
            type: "submit",
            size: "large",
            isFullWidth: true,
            isLoading,
            children: /* @__PURE__ */ _jsx30(Translation, {
              id: "actions.setPassword"
            })
          })
        })]
      })
    }), isSuccess && /* @__PURE__ */ _jsx30(Container12, {
      background: colors15.surface.affirmSoft,
      padding: "24px",
      radius: radius10.medium,
      role: "status",
      children: /* @__PURE__ */ _jsxs27(Flexer23, {
        column: true,
        gap: "16px",
        alignCenter: true,
        children: [/* @__PURE__ */ _jsx30(Line13, {
          children: /* @__PURE__ */ _jsx30(Translation, {
            id: "success.passwordSet"
          })
        }), /* @__PURE__ */ _jsx30(Button17, {
          onClick: () => history.push(loginPath ?? "/"),
          children: /* @__PURE__ */ _jsx30(Translation, {
            id: "actions.login"
          })
        })]
      })
    })]
  });
};

// src/hooks/use-clear-user-metadata-from-hash.ts
import { useCallback as useCallback5 } from "react";
import { useHistory as useHistory11 } from "react-router-dom";
var useClearUserMetadataFromHash = () => {
  const history = useHistory11();
  const {
    pathname,
    search,
    hash
  } = history.location;
  const hasMetaHash = typeof hash === "string" && hash.startsWith("#meta");
  const currentUrlWithoutHash = `${pathname}${search}`;
  const clearUserMetadataFromHash = useCallback5(() => {
    if (hasMetaHash) {
      history.replace(currentUrlWithoutHash);
    }
  }, [currentUrlWithoutHash, hasMetaHash, history]);
  return {
    clearUserMetadataFromHash
  };
};

// src/hooks/use-signin-with-custom-token.ts
import { getAuth as getAuth15, signInWithCustomToken } from "firebase/auth";
import { useState as useState28 } from "react";
import { useHistory as useHistory12 } from "react-router-dom";
var useSignInWithCustomToken = () => {
  const history = useHistory12();
  const [isLoading, setIsLoading] = useState28(false);
  const [error, setError] = useState28(null);
  const signInWithCustomTokenFn = ({
    customToken,
    redirectUrl
  }) => {
    const auth = getAuth15();
    if (!auth) {
      throw new Error("Firebase auth is not initialized");
    }
    setIsLoading(true);
    setError(null);
    signInWithCustomToken(auth, customToken).then(() => {
      history.push(redirectUrl);
    }).catch((error2) => {
      setError(error2);
      setIsLoading(false);
    });
  };
  return {
    signInWithCustomToken: signInWithCustomTokenFn,
    isLoading,
    error
  };
};

// src/hooks/use-resolve-magic-link.ts
import { useEffect as useEffect7 } from "react";
var useResolveMagicLink = ({
  customToken,
  redirectUrl,
  onError,
  hasError
}) => {
  const {
    signInWithCustomToken: signInWithCustomToken2,
    error: errorSignInWithCustomToken
  } = useSignInWithCustomToken();
  useEffect7(() => {
    if (hasError || !!errorSignInWithCustomToken)
      onError();
  }, [errorSignInWithCustomToken, hasError, onError]);
  useEffect7(() => {
    if (!customToken || !redirectUrl)
      return;
    signInWithCustomToken2({
      customToken,
      redirectUrl
    });
  }, [customToken, redirectUrl, signInWithCustomToken2]);
};

// src/index.ts
var Auth = {
  Modal: AuthModal,
  LockscreenLayout,
  LoginForm,
  Provider,
  ResetPasswordForm,
  SetPasswordForm,
  SignupForm,
  AuthManagement,
  MfaEnforcer
};
export {
  Auth,
  AuthModalHash,
  getFirstAndLastNameFromDisplayName,
  getIsPasswordLeaked,
  getToken,
  parseUserMetadataFromHash,
  useClearUserMetadataFromHash,
  useFirebase,
  useLogout,
  useResolveMagicLink,
  useSignInWithCustomToken
};
//# sourceMappingURL=index.js.map